{
  "note": "Generated by scripts/hero-art.ts; do not edit by hand.",
  "practices": [
    {
      "do": "Keep well-child visits on the Bright Futures schedule for your child's age",
      "image": "/images/practices/aap-bright-futures--aap-well-visits.webp?v=a57c0729",
      "chip": "Established",
      "expert": "AAP Bright Futures",
      "url": "https://www.aap.org/en/practice-management/care-delivery-approaches/periodicity-schedule/"
    },
    {
      "do": "Build regular aerobic activity and muscle-strengthening work into the week",
      "image": "/images/practices/acog-womens-health--acog-activity.webp?v=afd52ed0",
      "chip": "Established",
      "expert": "ACOG Women's Health",
      "url": "https://www.acog.org/womens-health/faqs/weight-control-eating-right-and-keeping-fit"
    },
    {
      "do": "Clean between the teeth once daily",
      "image": "/images/practices/ada-mouthhealthy--ada-between.webp?v=73872edc",
      "chip": "Established",
      "expert": "ADA MouthHealthy",
      "url": "https://www.mouthhealthy.org/oral-health-recommendations"
    },
    {
      "do": "Cut down on canned food",
      "image": "/images/practices/adler--adl-cans.webp?v=cfbecc1c",
      "chip": "Contested",
      "expert": "Lara Adler",
      "url": "https://www.laraadler.com/most-detoxes-miss-the-point-heres-why/"
    },
    {
      "do": "Set aside enough time for 7 to 9 hours of sleep each night",
      "image": "/images/practices/aha-lifes-essential-8--aha-adult-sleep.webp?v=1f258dec",
      "chip": "Established",
      "expert": "American Heart Association Life's Essential 8",
      "url": "https://www.heart.org/en/healthy-living/healthy-lifestyle/lifes-essential-8"
    },
    {
      "do": "Review the ACS mammography schedule with a clinician beginning in your 40s",
      "image": "/images/practices/american-cancer-society-prevention--acs-breast.webp?v=1d411b55",
      "chip": "Established",
      "expert": "American Cancer Society Prevention and Screening",
      "url": "https://www.cancer.org/cancer/types/breast-cancer/screening-tests-and-early-detection/american-cancer-society-recommendations-for-the-early-detection-of-breast-cancer.html"
    },
    {
      "do": "Before you look anything up for your child, ask them what they think first",
      "image": "/images/practices/amin--ami-ai-firstturn.webp?v=30400a7e",
      "chip": "Expert viewpoint",
      "expert": "Mona Amin",
      "url": "https://newsletter.pedsdoctalk.com/p/is-ai-going-to-ruin-our-children-s-development"
    },
    {
      "do": "Take 3 to 6 mg of caffeine per kg of body weight on training days",
      "image": "/images/practices/aragon--ara-caffeine.webp?v=bd4ee6f2",
      "chip": "Established",
      "expert": "Alan Aragon",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8471721/"
    },
    {
      "do": "Train the lowering half of your lifts deliberately, and add step-downs",
      "image": "/images/practices/attia--att-eccentric.webp?v=a7aa4e72",
      "chip": "Expert viewpoint",
      "expert": "Peter Attia",
      "url": "https://peterattiamd.com/avoiding-injury-part-i-eccentric-strength/"
    },
    {
      "do": "Request an accommodation tied to the setting where ADHD causes impairment",
      "image": "/images/practices/barkley--bar-accommodation.webp?v=f4d4b4e2",
      "chip": "Established",
      "expert": "Russell Barkley",
      "url": "https://www.russellbarkley.org/factsheets/ADHD_School_Accommodations.pdf"
    },
    {
      "do": "Take a vitamin B12 supplement if you eat a plant-exclusive diet",
      "image": "/images/practices/barnard--bar-b12-vegan.webp?v=fd9d9401",
      "chip": "Established",
      "expert": "Neal Barnard",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC7705596/"
    },
    {
      "do": "Wear sunscreen on your face every day, and on your body whenever it is exposed",
      "image": "/images/practices/baumann--bau-spf-daily.webp?v=db4c95ee",
      "chip": "Established",
      "expert": "Leslie Baumann",
      "url": "https://skintypesolutions.com/blogs/skincare/sunscreen-safety"
    },
    {
      "do": "Train twice a week and treat that as the whole programme",
      "image": "/images/practices/ben-patrick--bp-twice-weekly.webp?v=92e83388",
      "chip": "Expert viewpoint",
      "expert": "Ben Patrick",
      "url": "https://tim.blog/2025/11/13/ben-patrick-kneesovertoesguy-transcript/"
    },
    {
      "do": "Remove wheat, corn and rice from your diet",
      "image": "/images/practices/berry--ber-grains.webp?v=6d900eb5",
      "chip": "Contested",
      "expert": "Ken D. Berry",
      "url": "https://drberry.com/pages/proper-human-diet"
    },
    {
      "do": "Eat 1 to 1.5 grams of protein per kilogram of body weight a day",
      "image": "/images/practices/bikman--bik-protein-gkg.webp?v=24cdd4b7",
      "chip": "Established",
      "expert": "Benjamin T. Bikman",
      "url": "https://magazine.byu.edu/article/the-diet-of-champions/"
    },
    {
      "do": "Ask your doctor what they mean by the word treatment",
      "image": "/images/practices/bjmiller--bjm-ask-treatment.webp?v=76868302",
      "chip": "Expert viewpoint",
      "expert": "BJ Miller",
      "url": "https://geripal.org/2019/08/BJ-Miller-Book.html"
    },
    {
      "do": "Keep one short blessing somewhere you will see it and read it on the bad days",
      "image": "/images/practices/bowler--kb-blessing-daily.webp?v=5e17ac4b",
      "chip": "Expert viewpoint",
      "expert": "Kate Bowler",
      "url": "https://katebowler.com/download/a-blessing-for-being-human/"
    },
    {
      "do": "Name the shape your main sport holds you in, and spend time in its opposite",
      "image": "/images/practices/bowman--bow-balance-your-sport.webp?v=7e1abe75",
      "chip": "Expert viewpoint",
      "expert": "Katy Bowman",
      "url": "https://share.transistor.fm/s/93079f80"
    },
    {
      "do": "Stop drinking alcohol at least three hours before bed",
      "image": "/images/practices/breus--brs-alcohol-3h.webp?v=0cc0b61f",
      "chip": "Established",
      "expert": "Michael J. Breus",
      "url": "https://sleepdoctor.com/pages/health/alcohol-and-sleep"
    },
    {
      "do": "Start a new practice at two minutes, not thirty",
      "image": "/images/practices/brewer--bre-2min-start.webp?v=1e7212de",
      "chip": "Expert viewpoint",
      "expert": "Judson Brewer",
      "url": "https://drjud.com/what-is-the-habit-loop/"
    },
    {
      "do": "Keep the bedroom quiet, dark, and at 65-70°F (18-21°C)",
      "image": "/images/practices/bryan-johnson--bjo-bedroomtemp.webp?v=37bf06c1",
      "chip": "Established",
      "expert": "Bryan Johnson",
      "url": "https://protocol.bryanjohnson.com/"
    },
    {
      "do": "Eat at least half a cup of cooked beans every day",
      "image": "/images/practices/buettner--bu-beans.webp?v=f4d5f4f0",
      "chip": "Established",
      "expert": "Dan Buettner",
      "url": "https://www.bluezones.com/recipes/food-guidelines/"
    },
    {
      "do": "Add fermented foods to what you already eat",
      "image": "/images/practices/bulsiewicz--bul-ferment-daily.webp?v=a789a1bc",
      "chip": "Emerging",
      "expert": "Will Bulsiewicz",
      "url": "https://zoe.com/learn/podcast-gut-bugs"
    },
    {
      "do": "Clean between the teeth once daily with floss or an appropriate interdental tool",
      "image": "/images/practices/burhenne--bur-between.webp?v=8b017880",
      "chip": "Established",
      "expert": "Mark Burhenne",
      "url": "https://askthedentist.com/wp-content/uploads/2019/11/28-Day-Oral-Microbiome-Reset.pdf"
    },
    {
      "do": "Steam or boil starchy foods rather than microwaving them to browning",
      "image": "/images/practices/burkart--bur-acrylamide.webp?v=9e58ba0e",
      "chip": "Established",
      "expert": "Yvonne Burkart",
      "url": "https://dryvonneburkart.com/the-hidden-dangers-of-microwaving-plastic-simple-swaps-for-a-safer-low-toxin-kitchen/"
    },
    {
      "do": "Aim for about 10 percent of your calories from protein, and get it from plants",
      "image": "/images/practices/campbell--cam-protein10.webp?v=fe629d00",
      "chip": "Contested",
      "expert": "T. Colin Campbell",
      "url": "https://nutritionstudies.org/the-upper-safe-limit-for-protein-consumption-excerpt/"
    },
    {
      "do": "Avoid alcohol or keep it very low",
      "image": "/images/practices/carvalho--car-alcohol.webp?v=0bbcbb91",
      "chip": "Established",
      "expert": "Gil Carvalho",
      "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified"
    },
    {
      "do": "Lower your risk of common cancers by making healthy choices",
      "image": "/images/practices/cdc-prevention--cdc-cancer-prevention.webp?v=2fb304fd",
      "chip": "Established",
      "expert": "CDC Prevention Guidance",
      "url": "https://www.cdc.gov/cancer/prevention/index.html"
    },
    {
      "do": "Choose fatty cuts of meat over lean ones",
      "image": "/images/practices/chaffee--cha-fatty-cuts.webp?v=f513619b",
      "chip": "Contested",
      "expert": "Anthony Chaffee",
      "url": "https://dranthonychaffee.com/blog/what-is-the-carnivore-diet"
    },
    {
      "do": "Breathe in for three seconds, hold for four, breathe out for five",
      "image": "/images/practices/chatterjee--cha-345breath.webp?v=de0d91f9",
      "chip": "Emerging",
      "expert": "Rangan Chatterjee",
      "url": "https://drchatterjee.com/blog/5-breathing-techniques-help-reduce-stress/"
    },
    {
      "do": "Salt your food deliberately, aiming at roughly 1 to 3 teaspoons of salt a day",
      "image": "/images/practices/cho--cho-salt-daily.webp?v=e040f963",
      "chip": "Contested",
      "expert": "Judy Cho",
      "url": "https://www.nutritionwithjudy.com/sole-water-recipe-balancing-electrolytes/"
    },
    {
      "do": "Put the equipment for a practice directly in the path you already walk",
      "image": "/images/practices/clear--cle-flow.webp?v=66f70b5a",
      "chip": "Expert viewpoint",
      "expert": "James Clear",
      "url": "https://jamesclear.com/power-of-environment"
    },
    {
      "do": "Protect sleep, manage stress, and sweat regularly",
      "image": "/images/practices/cohen--coh-3s.webp?v=f58d6a8b",
      "chip": "Contested",
      "expert": "Aly Cohen",
      "url": "https://adamrinde.substack.com/p/episode-116-detoxify-your-life-dr"
    },
    {
      "do": "Move your evening meal earlier and keep to about three meals a day",
      "image": "/images/practices/dagostino--dag-dinner-early.webp?v=16de3616",
      "chip": "Expert viewpoint",
      "expert": "Dominic P. D'Agostino",
      "url": "https://tim.blog/2025/09/03/dr-dominic-dagostino-all-things-ketones/"
    },
    {
      "do": "Eat 2 to 4 grams of plant omega-3 (ALA) a day if you do not eat fish",
      "image": "/images/practices/davis--dav-ala-2to4g.webp?v=5c44d569",
      "chip": "Established",
      "expert": "Brenda Davis",
      "url": "https://brendadavisrd.com/fine-tuning-plant-based-diets/"
    },
    {
      "do": "Donate to LEV Foundation to accelerate the mouse rejuvenation programme",
      "image": "/images/practices/degrey--adg-donate.webp?v=d9bd694e",
      "chip": "Expert viewpoint",
      "expert": "Aubrey de Grey",
      "url": "https://www.levf.org/december-2025-update"
    },
    {
      "do": "Drink when you are thirsty and stop counting glasses",
      "image": "/images/practices/dentremont--den-drink-to-thirst.webp?v=84dafb6a",
      "chip": "Established",
      "expert": "Yvette d'Entremont",
      "url": "http://web.archive.org/web/20240125021958id_/https://scibabe.com/mos-how-to-drink-water"
    },
    {
      "do": "Minimize foods and drinks with added sugar",
      "image": "/images/practices/dietary-guidelines-americans--dga-added-sugar.webp?v=6f04ea02",
      "chip": "Established",
      "expert": "Dietary Guidelines for Americans",
      "url": "https://cdn.realfood.gov/DGA.pdf"
    },
    {
      "do": "Cut refined carbohydrates: sugar, flour, fruit juice and processed cereals",
      "image": "/images/practices/ede--ede-no-refined-carbs.webp?v=7e534cfc",
      "chip": "Established",
      "expert": "Georgia A. Ede",
      "url": "https://www.psychologytoday.com/us/blog/diagnosis-diet/201712/top-ten-tips-for-a-healthier-brain-in-2018"
    },
    {
      "do": "Maintain fuel-burning appliances and vent them correctly",
      "image": "/images/practices/epa-indoor-air--epa-combustion.webp?v=a47214b0",
      "chip": "Established",
      "expert": "EPA Indoor Air Quality",
      "url": "https://www.epa.gov/indoor-air-quality-iaq/care-your-air-guide-indoor-air-quality"
    },
    {
      "do": "Refrigerate or freeze perishable food promptly",
      "image": "/images/practices/fda-food-safety--fda-chill.webp?v=bc70d6bd",
      "chip": "Established",
      "expert": "FDA Consumer Food Safety",
      "url": "https://www.fda.gov/consumers/consumer-updates/are-you-storing-food-safely"
    },
    {
      "do": "Choose foods by micronutrients per calorie, using his ANDI scores as the ranking",
      "image": "/images/practices/fuhrman--fuh-andi.webp?v=e4342dbf",
      "chip": "Expert viewpoint",
      "expert": "Joel H. Fuhrman",
      "url": "https://www.drfuhrman.com/blog/128/andi-food-scores-rating-the-nutrient-density-of-foods"
    },
    {
      "do": "Drink less alcohol and drink more water",
      "image": "/images/practices/fullyrawkristina--fkr-alcohol.webp?v=925efc28",
      "chip": "Established",
      "expert": "Kristina Carrillo-Bucaram",
      "url": "https://www.fullyraw.com/blog/10-simple-ways-to-boost-your-immune-system"
    },
    {
      "do": "Eat three meals a day at a table and nothing in between. No snacks.",
      "image": "/images/practices/fung--fun-nosnack.webp?v=3f74d2cd",
      "chip": "Contested",
      "expert": "Jason Fung",
      "url": "https://www.thefastingmethod.com/the-perils-of-snacking-hormonal-obesity-xiii/"
    },
    {
      "do": "Take 3 to 5 grams of creatine monohydrate a day and skip the loading phase",
      "image": "/images/practices/galpin--gal-creatine.webp?v=2adcc777",
      "chip": "Established",
      "expert": "Andy Galpin",
      "url": "https://www.hubermanlab.com/episode/dr-andy-galpin-optimal-nutrition-and-supplementation-for-fitness"
    },
    {
      "do": "Eat legumes most days: beans, lentils, chickpeas, peas, soy",
      "image": "/images/practices/gardner--gar-legumes.webp?v=1a9acffc",
      "chip": "Established",
      "expert": "Christopher D. Gardner",
      "url": "https://www.levels.com/blog/diet-advice-christopher-gardner"
    },
    {
      "do": "Scatter four one-minute bouts of vigorous bodyweight exercise through your day",
      "image": "/images/practices/gibala--gib-snacks-4min.webp?v=ff968156",
      "chip": "Emerging",
      "expert": "Martin J. Gibala",
      "url": "https://www.realexercisescience.com/p/exercise-snacks-and-vilpa-the-ultimate"
    },
    {
      "do": "Eat at least 16 oz of raw leafy greens and cruciferous vegetables every day",
      "image": "/images/practices/goldner--gol-greens-16oz.webp?v=1f7416da",
      "chip": "Emerging",
      "expert": "Brooke Goldner",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10949923/"
    },
    {
      "do": "Store acidic foods in glass rather than plastic or a can",
      "image": "/images/practices/gomberg--gom-acid.webp?v=fd068cb1",
      "chip": "Established",
      "expert": "Beatrice Gomberg",
      "url": "https://taborplace.co/blogs/plastic-is-toxic/not-all-plastic-exposure-is-created-equal"
    },
    {
      "do": "If you have cancer, or might have an undetected one, do not inject BPC-157",
      "image": "/images/practices/greenfield--bgr-bpc157-cancer.webp?v=978af51c",
      "chip": "Expert viewpoint",
      "expert": "Ben Greenfield",
      "url": "https://bengreenfieldlife.com/podcast/solo-503/"
    },
    {
      "do": "Take a B12 supplement if you eat a plant-based or plant-centred diet",
      "image": "/images/practices/greger--gre-b12-required.webp?v=af9c60ed",
      "chip": "Established",
      "expert": "Michael Greger",
      "url": "https://nutritionfacts.org/video/the-best-source-of-vitamin-b12-supplements-shots-or-fortified-foods/"
    },
    {
      "do": "Get 700 to 1200 mg of calcium a day, from food",
      "image": "/images/practices/guess--gue-calcium-700-1200.webp?v=a94fc539",
      "chip": "Established",
      "expert": "Nicola Guess",
      "url": "https://drguess.substack.com/p/nutrition-for-females-over-50-years"
    },
    {
      "do": "Delay independent social-media accounts until age 16 when circumstances allow",
      "image": "/images/practices/haidt--hai-delaysocial.webp?v=9c79c3fc",
      "chip": "Contested",
      "expert": "Jonathan Haidt",
      "url": "https://www.anxiousgeneration.com/"
    },
    {
      "do": "Practise with other people rather than alone",
      "image": "/images/practices/harris--har-community.webp?v=976df135",
      "chip": "Expert viewpoint",
      "expert": "Dan Harris",
      "url": "https://www.danharris.com/meditation-app"
    },
    {
      "do": "Aim for an ApoB under 80 mg/dl, or under 50 mg/dl if you are high risk",
      "image": "/images/practices/hill--hil-apob-target.webp?v=b5041c70",
      "chip": "Expert viewpoint",
      "expert": "Simon Hill",
      "url": "https://theproof.com/wp-content/uploads/2023/06/TP_LipidCheatSheet.pdf"
    },
    {
      "do": "Get outside again in the late afternoon or early evening, before sunset",
      "image": "/images/practices/huberman--hub-afternoon-light.webp?v=aad0da4d",
      "chip": "Emerging",
      "expert": "Andrew D. Huberman",
      "url": "https://www.hubermanlab.com/newsletter/using-light-for-health"
    },
    {
      "do": "Sleep 7 to 8 hours a night to let bone rebuild",
      "image": "/images/practices/hyman--hym-bone-sleep.webp?v=a0b2a597",
      "chip": "Emerging",
      "expert": "Mark Hyman",
      "url": "https://drhyman.com/blogs/content/are-your-bones-aging-faster-than-you-are-here-s-why-it-matters"
    },
    {
      "do": "Do a fifteen-minute house chore after dinner instead of sitting down",
      "image": "/images/practices/inchauspe--inc-house-chore.webp?v=b00e2524",
      "chip": "Expert viewpoint",
      "expert": "Jessie Inchauspé",
      "url": "https://www.glucosegoddess.com/pages/science-episode-move-after-eating"
    },
    {
      "do": "Take a genuine two-week break from hard training about twice a year",
      "image": "/images/practices/israetel--isr-active-rest.webp?v=2a2d21fe",
      "chip": "Expert viewpoint",
      "expert": "Mike Israetel",
      "url": "https://podscripts.co/podcasts/modern-wisdom/842-dr-mike-israetel-exercise-scientists-masterclass-on-recovery-stress-management"
    },
    {
      "do": "Buy produce from a local grower where you can during a cyclosporiasis outbreak",
      "image": "/images/practices/jetelina--jet-cyclo-local.webp?v=b3fb37c9",
      "chip": "Expert viewpoint",
      "expert": "Katelyn Jetelina",
      "url": "https://yourlocalepidemiologist.substack.com/p/top-10-cyclospora-questions"
    },
    {
      "do": "Build your healthspan on four things: eat, move, sleep, connect",
      "image": "/images/practices/kaeberlein--kae-pillars.webp?v=9a9bc6d5",
      "chip": "Established",
      "expert": "Matt Kaeberlein",
      "url": "https://podcasters.spotify.com/pod/show/the-optispan-podcast-with/episodes/Everything-I-do-for-Healthspan-and-why-I-skip-THESE-Supplements-e3dbv47"
    },
    {
      "do": "Cut added sugar and fruit juice, and keep eating whole fruit",
      "image": "/images/practices/kahn--kah-added-sugar.webp?v=1fabf550",
      "chip": "Established",
      "expert": "Joel Kahn",
      "url": "https://www.kahnlongevitycenter.com/blog/added-sugars-in-the-diet-not-fruit-related-to-increased-risk-of-heart-disease"
    },
    {
      "do": "Define what you can usually do now without causing a major symptom crash",
      "image": "/images/practices/khan--kha-baseline.webp?v=3de310a1",
      "chip": "Expert viewpoint",
      "expert": "Zeest Khan",
      "url": "https://longcovidmd.com/long-covid-rundown-pacing-and-the-push-crash-cycle/"
    },
    {
      "do": "Do not conclude that cell therapy is fake because clinic offerings are",
      "image": "/images/practices/knoepfler--kno-approvedreal.webp?v=88d3dcee",
      "chip": "Established",
      "expert": "Paul Knoepfler",
      "url": "https://ipscell.com/2025/01/updated-2025-list-of-fda-approved-cell-and-gene-therapies/"
    },
    {
      "do": "Feed babies from glass or stainless steel bottles rather than plastic ones",
      "image": "/images/practices/lanphear--lan-babybottle.webp?v=97144fcc",
      "chip": "Emerging",
      "expert": "Bruce Lanphear",
      "url": "https://littlethingsmatter.ca/toxic/microplastics-2/"
    },
    {
      "do": "Dance, socially, for longer than one song",
      "image": "/images/practices/lieberman--lie-dance.webp?v=16ef380b",
      "chip": "Emerging",
      "expert": "Daniel E. Lieberman",
      "url": "https://www.mountsinai.org/about/newsroom/podcasts/road-resilience/archive/weirdos-guide"
    },
    {
      "do": "Keep all your eating inside a twelve-hour window",
      "image": "/images/practices/longo--lon-12h.webp?v=d8a8ef71",
      "chip": "Emerging",
      "expert": "Valter Longo",
      "url": "https://valterlongo.com/daily-longevity-diet-for-adults/"
    },
    {
      "do": "Do not swap sugar for a synthetic sweetener; drop the sweetness instead",
      "image": "/images/practices/lustig--lus-avoidnns.webp?v=04bbe436",
      "chip": "Contested",
      "expert": "Robert H. Lustig",
      "url": "https://robertlustig.com/2019/09/synthetic-or-non-nutritive-sweeteners/"
    },
    {
      "do": "Move your plate toward a one-to-one ratio of carbohydrate grams to protein grams",
      "image": "/images/practices/lyon--lyo-carb-ratio.webp?v=42395512",
      "chip": "Expert viewpoint",
      "expert": "Gabrielle Lyon",
      "url": "https://drgabriellelyon.com/podcast_list/stop-overeating-carbs-the-11-protein-to-carb-ratio-rule-for-metabolism/"
    },
    {
      "do": "Keep a short bladder diary of drinks, bathroom visits, urgency and leaks",
      "image": "/images/practices/malik--mal-bladderdiary.webp?v=8ed0d74e",
      "chip": "Established",
      "expert": "Rena Malik",
      "url": "https://renamalikmd.com/oab-guide-2/"
    },
    {
      "do": "Ask for a specific form of support before capacity is exhausted",
      "image": "/images/practices/mccabe--mcc-ask-help.webp?v=f8560ae6",
      "chip": "Expert viewpoint",
      "expert": "Jessica McCabe",
      "url": "https://www.understood.org/en/podcasts/adhd-aha/jessica-mccabe-motherhood-social-anxiety-adhd-medication"
    },
    {
      "do": "Get down to the floor with a lunge rather than a deep squat",
      "image": "/images/practices/mcgill--mcg-lunge-to-floor.webp?v=5097ff36",
      "chip": "Expert viewpoint",
      "expert": "Stuart McGill",
      "url": "https://www.backfitpro.com/pdf/selecting_back_exercises.pdf"
    },
    {
      "do": "Before you change a habit, spend a stretch changing nothing and just watching it",
      "image": "/images/practices/mcgonigal--mcg-awarenessfirst.webp?v=e9b1fb59",
      "chip": "Expert viewpoint",
      "expert": "Kelly McGonigal",
      "url": "https://soundstrue.com/a/resources/transcript/the-neuroscience-of-change/"
    },
    {
      "do": "Add a source of fat and fiber to a carbohydrate-containing meal",
      "image": "/images/practices/means--mea-fatfiber.webp?v=64e88e6a",
      "chip": "Emerging",
      "expert": "Casey Means",
      "url": "https://www.hubermanlab.com/episode/dr-casey-means-transform-your-health-by-improving-metabolism-hormone-blood-sugar-regulation"
    },
    {
      "do": "Cut back on potato chips and potatoes if you are trying not to gain weight",
      "image": "/images/practices/mozaffarian--moz-chips.webp?v=e49e7666",
      "chip": "Emerging",
      "expert": "Dariush Mozaffarian",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3151731/"
    },
    {
      "do": "If you drink, never exceed one drink in a day as a woman or two as a man",
      "image": "/images/practices/mukamal--muk-ceiling.webp?v=2599db94",
      "chip": "Expert viewpoint",
      "expert": "Kenneth J. Mukamal",
      "url": "https://www.harvardmagazine.com/2025/01/harvard-study-how-much-alcohol-is-safe"
    },
    {
      "do": "Do not describe the potassium AI as an RDA",
      "image": "/images/practices/national-academies-dri--dri-potassium-uncertain.webp?v=2c438f62",
      "chip": "Established",
      "expert": "National Academies Dietary Reference Intakes",
      "url": "https://nap.nationalacademies.org/catalog/25353/dietary-reference-intakes-for-sodium-and-potassium"
    },
    {
      "do": "Drink as little alcohol as possible",
      "image": "/images/practices/nestle--nes-alcohol.webp?v=c2712bf4",
      "chip": "Contested",
      "expert": "Marion Nestle",
      "url": "https://www.foodpolitics.com/2026/01/maha-dietary-guidelines-v-the-alcohol-non-recommendation/"
    },
    {
      "do": "Add regular physical activity that matches your current abilities and health",
      "image": "/images/practices/nia-healthy-aging--nia-move-more.webp?v=e8dbd3e8",
      "chip": "Established",
      "expert": "NIH National Institute on Aging: Healthy Aging",
      "url": "https://www.nia.nih.gov/health/exercise-and-physical-activity/health-benefits-exercise-and-physical-activity"
    },
    {
      "do": "List likely obstacles and decide in advance how you will restart after a lapse",
      "image": "/images/practices/nice-lifestyle-wellbeing--nice-coping-plan.webp?v=9610e5f8",
      "chip": "Established",
      "expert": "NICE Lifestyle and Wellbeing",
      "url": "https://www.nice.org.uk/guidance/ph49/chapter/Recommendations"
    },
    {
      "do": "Estimate calcium from food before adding a supplement",
      "image": "/images/practices/nih-ods--ods-calcium-food.webp?v=0bcedef4",
      "chip": "Established",
      "expert": "NIH Office of Dietary Supplements",
      "url": "https://ods.od.nih.gov/factsheets/Calcium-Consumer/"
    },
    {
      "do": "Do your cardio after lifting, or at a separate time of day",
      "image": "/images/practices/nippard--nip-cardio-after.webp?v=908845eb",
      "chip": "Established",
      "expert": "Jeff Nippard",
      "url": "https://www.youtube.com/watch?v=3Y2vxKsaK9A"
    },
    {
      "do": "Cut total carbohydrate to under about 75 g a day, going lower if you need to",
      "image": "/images/practices/noakes--noa-carb75.webp?v=31377623",
      "chip": "Contested",
      "expert": "Timothy David Noakes",
      "url": "https://scielo.org.za/scielo.php?pid=S0256-95742013001100013&script=sci_arttext"
    },
    {
      "do": "Treat alcohol as a cost you are choosing to pay, and keep the amount low",
      "image": "/images/practices/norton--nor-alcohol.webp?v=d18866bb",
      "chip": "Contested",
      "expert": "Layne Norton",
      "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/the-pillars-of-health-episode-2/"
    },
    {
      "do": "Take a week off caffeine every few months",
      "image": "/images/practices/olien--oli-caffeine-cycle.webp?v=4cb53abe",
      "chip": "Expert viewpoint",
      "expert": "Darin Olien",
      "url": "https://podcasts.happyscribe.com/the-darin-olien-show/23-fatal-conveniences-caffeine-consuming-coffee-with-caution"
    },
    {
      "do": "Put the phone in another room overnight if bedroom access is disrupting sleep",
      "image": "/images/practices/orben--orb-bedroom.webp?v=53ad2206",
      "chip": "Established",
      "expert": "Amy Orben",
      "url": "https://www.cam.ac.uk/stories/socialmedia"
    },
    {
      "do": "Hold total fat to about 10 percent of calories on a whole-foods vegetarian diet",
      "image": "/images/practices/ornish--orn-fat10.webp?v=be331170",
      "chip": "Contested",
      "expert": "Dean Michael Ornish",
      "url": "https://pubmed.ncbi.nlm.nih.gov/9863851/"
    },
    {
      "do": "Progress gradually toward a valued form of physical activity",
      "image": "/images/practices/osullivan--osu-activity.webp?v=2f8ef3d0",
      "chip": "Established",
      "expert": "Peter O'Sullivan",
      "url": "https://www.iasp-pain.org/wp-content/uploads/2024/06/cognitive-functional-therapy-msk-fact-sheet_R1.pdf"
    },
    {
      "do": "Stop drinking alcohol, or try a month without it and judge from that",
      "image": "/images/practices/palmer--pal-no-alcohol.webp?v=f99cf238",
      "chip": "Contested",
      "expert": "Christopher M. Palmer",
      "url": "https://www.cnbc.com/2022/12/16/harvard-brain-expert-shares-what-he-never-does-in-order-to-stay-sharp-energized-healthy.html"
    },
    {
      "do": "Keep the same eating window on work days and days off",
      "image": "/images/practices/panda--pan-consistency.webp?v=b27c074d",
      "chip": "Emerging",
      "expert": "Satchidananda Panda",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8905332/"
    },
    {
      "do": "Open one work meeting a week with a real question instead of small talk",
      "image": "/images/practices/perel--per-antismalltalk.webp?v=8ba72341",
      "chip": "Expert viewpoint",
      "expert": "Esther Perel",
      "url": "https://www.ted.com/talks/esther_perel_the_routines_rituals_and_boundaries_we_need_in_stressful_times"
    },
    {
      "do": "Do not drop below about 1000 kcal a day, whatever diet you are on",
      "image": "/images/practices/phinney--phi-avoid-vlcd.webp?v=e3d05e43",
      "chip": "Expert viewpoint",
      "expert": "Stephen D. Phinney",
      "url": "https://www.virtahealth.com/blog/well-formulated-ketogenic-diet"
    },
    {
      "do": "As an adult, train all major muscle groups on at least two days each week",
      "image": "/images/practices/physical-activity-guidelines-americans--pag-adult-strength.webp?v=2487fecc",
      "chip": "Established",
      "expert": "Physical Activity Guidelines for Americans",
      "url": "https://health.gov/sites/default/files/2019-09/Physical_Activity_Guidelines_2nd_edition.pdf"
    },
    {
      "do": "Break up long stretches of sitting during the day",
      "image": "/images/practices/picard--pic-break-sitting.webp?v=e6ca791c",
      "chip": "Established",
      "expert": "Martin Picard",
      "url": "https://tseenergy.substack.com/p/mitochondria-and-brain-health"
    },
    {
      "do": "Upgrade the furnace filter and run the fan continuously rather than on auto",
      "image": "/images/practices/pompa--pom-airfilter.webp?v=3bac7fe9",
      "chip": "Emerging",
      "expert": "Dr. Daniel Pompa",
      "url": "https://drpompa.com/cellular-detox/detox-your-life-my-toxic-top-10/"
    },
    {
      "do": "Do not change how much coffee you drink because of the new heart advisory",
      "image": "/images/practices/prasad--pra-coffee-no-target.webp?v=bb3a678d",
      "chip": "Expert viewpoint",
      "expert": "Vinay Prasad",
      "url": "https://www.drvinayprasad.com/p/coffee-and-the-heart-the-new-guidelines"
    },
    {
      "do": "Cut back on canned food and canned drinks",
      "image": "/images/practices/rhonda-patrick--rhp-mp-cans.webp?v=d4f4adb6",
      "chip": "Emerging",
      "expert": "Rhonda Patrick",
      "url": "https://www.foundmyfitness.com/episodes/microplastics"
    },
    {
      "do": "Create one external accountability signal for the habit you are trying to hold",
      "image": "/images/practices/richroll--rol-accountability.webp?v=dc1b4a3b",
      "chip": "Expert viewpoint",
      "expert": "Rich Roll",
      "url": "https://richroll.com/podcast/rich-980/"
    },
    {
      "do": "Stop heating food or water in plastic, and move food storage to glass or steel",
      "image": "/images/practices/romm--rom-no-plastic-heat.webp?v=a73d914e",
      "chip": "Emerging",
      "expert": "Aviva Romm",
      "url": "https://avivaromm.com/microplastics-and-nanoplastics/"
    },
    {
      "do": "Cut out coffee and tea, and drink filtered or spring water instead",
      "image": "/images/practices/saladino--sal-avoid-coffee.webp?v=c87e40ac",
      "chip": "Contested",
      "expert": "Paul Gregory Saladino",
      "url": "https://www.paulsaladinomd.com/psmd-newsletters/what-to-eat-on-a-carnivore-diet-your-carnivore-diet-meal-plan"
    },
    {
      "do": "Choose a trusted person and ask for a private time to talk",
      "image": "/images/practices/samhsa-find-support--samhsa-trusted-person.webp?v=04a1c5a8",
      "chip": "Established",
      "expert": "SAMHSA Find Support",
      "url": "https://www.samhsa.gov/find-support/how-to-cope/how-to-ask-for-help"
    },
    {
      "do": "Do some form of testing rather than guessing your intensities",
      "image": "/images/practices/sanmillan--ism-test-something.webp?v=a6c1de18",
      "chip": "Expert viewpoint",
      "expert": "Iñigo San Millán",
      "url": "https://www.trainingpeaks.com/coach-blog/zone-2-biochemistry-biomechanical-energy-inigo-san-millan/"
    },
    {
      "do": "Do thirty minutes of cardio when your mood is low",
      "image": "/images/practices/santos--san-cardio.webp?v=6a845666",
      "chip": "Contested",
      "expert": "Laurie R. Santos",
      "url": "https://cafe.com/stay-tuned/laurie-santos-happiness/"
    },
    {
      "do": "Take an easy week when you feel you need one, not because it is week four",
      "image": "/images/practices/schoenfeld--sch-deload-autoregulate.webp?v=4767f513",
      "chip": "Expert viewpoint",
      "expert": "Brad Schoenfeld",
      "url": "https://www.lookgreatnaked.com/blog/are-deloads-useless/"
    },
    {
      "do": "Eat a 150 gram mix of berries every day, fresh or frozen",
      "image": "/images/practices/schwarcz--sch-berries.webp?v=e62a4c2d",
      "chip": "Emerging",
      "expert": "Joe Schwarcz",
      "url": "https://www.mcgill.ca/oss/article/medical-health-and-nutrition/forget-supplements-and-bring-berries"
    },
    {
      "do": "Check heart-rate drift to find out whether your easy session was actually easy",
      "image": "/images/practices/seiler--sei-drift-check.webp?v=7a532057",
      "chip": "Expert viewpoint",
      "expert": "Stephen Seiler",
      "url": "https://scientifictriathlon.com/tts177/"
    },
    {
      "do": "Stop using alcohol to get to sleep",
      "image": "/images/practices/shelbyharris--sh-alcohol-second-half.webp?v=378dbe10",
      "chip": "Established",
      "expert": "Shelby Harris",
      "url": "https://drshelbyharris.com/why-sleep-matters/"
    },
    {
      "do": "Wear blue-blocking glasses for the hour before bed",
      "image": "/images/practices/siimland--sil-blueblock.webp?v=18447c5f",
      "chip": "Emerging",
      "expert": "Siim Land",
      "url": "https://www.siimland.co/my-longevity-routine"
    },
    {
      "do": "Eat about 30 different plant foods a week",
      "image": "/images/practices/sims--sim-30plants.webp?v=87a07058",
      "chip": "Emerging",
      "expert": "Stacy T. Sims",
      "url": "https://www.drstacysims.com/newsletters/articles/posts/perimenopause-vs-postmenopause-training-nutrition-guide"
    },
    {
      "do": "Understand that his own eating window is far shorter than the one he recommends",
      "image": "/images/practices/sinclair--sin-2hr.webp?v=081618ee",
      "chip": "Expert viewpoint",
      "expert": "David A. Sinclair",
      "url": "https://www.hubermanlab.com/episode/dr-david-sinclair-the-biology-of-slowing-and-reversing-aging"
    },
    {
      "do": "Move from sweetened yoghurt to plain yoghurt gradually rather than in one step",
      "image": "/images/practices/spector--spe-yogurt-wean.webp?v=2029dadf",
      "chip": "Expert viewpoint",
      "expert": "Tim Spector",
      "url": "https://zoe.com/learn/how-to-eat-sugar-without-gaining-weight"
    },
    {
      "do": "Eat about 800 grams of fruits and vegetables a day",
      "image": "/images/practices/starrett--str-800g.webp?v=6426f189",
      "chip": "Emerging",
      "expert": "Kelly Starrett",
      "url": "https://tim.blog/2023/04/01/kelly-starrett-transcript/"
    },
    {
      "do": "Wash your hands with soap and running water for at least 20 seconds",
      "image": "/images/practices/steier--ste-handwash20.webp?v=ef4d003f",
      "chip": "Established",
      "expert": "Jessica B. Steier",
      "url": "https://theunbiasedscipod.substack.com/p/our-hands-are-gross-heres-what-to"
    },
    {
      "do": "Drink less than you drink now, whatever that number is",
      "image": "/images/practices/stockwell--sto-lessisbest.webp?v=3f1cad09",
      "chip": "Established",
      "expert": "Tim Stockwell",
      "url": "https://news.uchicago.edu/big-brains-podcast-whats-truth-about-alcohols-benefits-and-risks"
    },
    {
      "do": "Do not treat a BPA free label as a reason to buy",
      "image": "/images/practices/swan--swa-bpafree.webp?v=f8213a94",
      "chip": "Contested",
      "expert": "Shanna H. Swan",
      "url": "https://www.hubermanlab.com/episode/dr-shanna-swan-how-to-safeguard-your-hormone-health-fertility"
    },
    {
      "do": "Choose eggs over cereal and cheese over crackers",
      "image": "/images/practices/teicholz--tei-eggs-not-cereal.webp?v=d653a3be",
      "chip": "Contested",
      "expert": "Nina Teicholz",
      "url": "https://ninateicholz.com/faqs/latest-science-on-nutrition-topics/"
    },
    {
      "do": "Learn or keep using a second language",
      "image": "/images/practices/topol--top-multilingual.webp?v=9f8b19af",
      "chip": "Emerging",
      "expert": "Eric Topol",
      "url": "https://erictopol.substack.com/p/multilingualism-and-extending-healthspan"
    },
    {
      "do": "Open windows, and run a HEPA filter if you have one",
      "image": "/images/practices/trasande--tra-airfilter.webp?v=71146a52",
      "chip": "Emerging",
      "expert": "Leonardo Trasande",
      "url": "https://nyulangone.org/news/seven-tips-reducing-your-exposure-microplastics-plastic-additives"
    },
    {
      "do": "If age 64 or younger, discuss anxiety screening in primary care",
      "image": "/images/practices/uspstf-recommendations--usp-anxiety.webp?v=d297e90d",
      "chip": "Established",
      "expert": "USPSTF Recommendations",
      "url": "https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/anxiety-adults-screening"
    },
    {
      "do": "Work through the free REACH forgiveness workbook in one or two sittings",
      "image": "/images/practices/vanderweele--tv-reach.webp?v=e9d073cd",
      "chip": "Emerging",
      "expert": "Tyler J. VanderWeele",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11812785/"
    },
    {
      "do": "Identify at least one person you could contact in a time of need",
      "image": "/images/practices/waldinger--wal-anchor.webp?v=b639bf8c",
      "chip": "Established",
      "expert": "Robert Waldinger",
      "url": "https://news.harvard.edu/gazette/story/2023/02/work-out-daily-ok-but-how-socially-fit-are-you/"
    },
    {
      "do": "Use the 30/30/3 rule to decide whether this is insomnia or a bad patch",
      "image": "/images/practices/walker--wal-3030-3.webp?v=130e21cf",
      "chip": "Established",
      "expert": "Matthew Walker",
      "url": "https://themattwalkerpodcast.buzzsprout.com/1821163/episodes/10976547-26-insomnia-part-1"
    },
    {
      "do": "Drink less alcohol or none",
      "image": "/images/practices/who-healthy-living--who-alcohol.webp?v=43daccbb",
      "chip": "Established",
      "expert": "WHO Healthy Living Guidance",
      "url": "https://www.who.int/news-room/fact-sheets/detail/alcohol"
    },
    {
      "do": "For acne, use a 2.5% benzoyl peroxide product rather than a stronger one",
      "image": "/images/practices/wong--won-bpo-25.webp?v=a367140c",
      "chip": "Established",
      "expert": "Michelle Wong",
      "url": "https://labmuffin.com/why-benzoyl-peroxide-is-a-great-acne-treatment/"
    },
    {
      "do": "Get up after roughly 20 to 30 minutes awake, and do not time it",
      "image": "/images/practices/wu--wu-2030-rule.webp?v=d683cab7",
      "chip": "Established",
      "expert": "Jade Wu",
      "url": "https://www.quickanddirtytips.com/articles/sleep-hygiene-doesnt-cure-insomnia-do-this-instead/"
    },
    {
      "do": "Work up to 30 g of fibre a day",
      "image": "/images/practices/yeo--yeo-fibre30.webp?v=a2877bb0",
      "chip": "Established",
      "expert": "Giles Yeo",
      "url": "https://www.sciencefocus.com/the-human-body/3-dieting-rules"
    },
    {
      "do": "Try mindfulness as one optional part of a broader pain-management plan",
      "image": "/images/practices/zoffness--zof-mindful.webp?v=13e5035f",
      "chip": "Emerging",
      "expert": "Rachel Zoffness",
      "url": "https://www.zoffness.com/resources"
    },
    {
      "do": "Write down your most important questions and bring them to the visit",
      "image": "/images/practices/acog-womens-health--acog-priorities.webp?v=1d00112e",
      "chip": "Established",
      "expert": "ACOG Women's Health",
      "url": "https://www.acog.org/womens-health/faqs/making-the-most-of-your-health-care-visit"
    },
    {
      "do": "Brush teeth twice daily for two minutes",
      "image": "/images/practices/ada-mouthhealthy--ada-brush.webp?v=3c926d69",
      "chip": "Established",
      "expert": "ADA MouthHealthy",
      "url": "https://www.mouthhealthy.org/all-topics-a-z/brushing-your-teeth"
    },
    {
      "do": "Open a window while you cook if your range hood does not vent outside",
      "image": "/images/practices/adler--adl-cookwindow.webp?v=92473af5",
      "chip": "Established",
      "expert": "Lara Adler",
      "url": "https://talkingtoxins.substack.com/p/gas-stoves-a-century-of-marketing"
    },
    {
      "do": "Know your blood pressure and review repeated high readings with a clinician",
      "image": "/images/practices/aha-lifes-essential-8--aha-bp-know.webp?v=a85bed9e",
      "chip": "Established",
      "expert": "American Heart Association Life's Essential 8",
      "url": "https://www.heart.org/en/healthy-living/healthy-lifestyle/lifes-essential-8/how-to-manage-blood-pressure-fact-sheet"
    },
    {
      "do": "Keep HPV vaccination on schedule for eligible children and young adults",
      "image": "/images/practices/american-cancer-society-prevention--acs-hpv.webp?v=85465011",
      "chip": "Established",
      "expert": "American Cancer Society Prevention and Screening",
      "url": "https://www.cancer.org/cancer/risk-prevention/hpv/hpv-vaccine.html"
    },
    {
      "do": "Do not give a young child an AI chatbot toy as a companion",
      "image": "/images/practices/amin--ami-ai-toy.webp?v=03995ef3",
      "chip": "Expert viewpoint",
      "expert": "Mona Amin",
      "url": "https://newsletter.pedsdoctalk.com/p/is-ai-going-to-ruin-our-children-s-development"
    },
    {
      "do": "Be suspicious of any health community where citing research is discouraged",
      "image": "/images/practices/aragon--ara-citations-allowed.webp?v=70839ccc",
      "chip": "Expert viewpoint",
      "expert": "Alan Aragon",
      "url": "https://www.alanaragonblog.com/2010/06/15/why-nutritional-dogma-dies-hard/"
    },
    {
      "do": "Avoid one meal a day if you are trying to hold on to muscle",
      "image": "/images/practices/attia--att-omad.webp?v=581f6f24",
      "chip": "Expert viewpoint",
      "expert": "Peter Attia",
      "url": "https://peterattiamd.com/the-impact-of-fasting-on-muscle-mass/"
    },
    {
      "do": "Break a distant task into short, concrete work units",
      "image": "/images/practices/barkley--bar-breakdown.webp?v=8f9bf31e",
      "chip": "Established",
      "expert": "Russell Barkley",
      "url": "https://www.guilford.com/books/Taking-Charge-of-Adult-ADHD/Russell-Barkley/9781462546855/contents"
    },
    {
      "do": "Drop dairy products from your diet",
      "image": "/images/practices/barnard--bar-drop-dairy.webp?v=42bc3752",
      "chip": "Contested",
      "expert": "Neal Barnard",
      "url": "https://www.pcrm.org/news/news-releases/usdas-myplate-making-americans-sick-says-doctors-group"
    },
    {
      "do": "Stop drinking milk and other liquid dairy, and keep butter, ghee and hard cheese",
      "image": "/images/practices/berry--ber-liquiddairy.webp?v=56712139",
      "chip": "Contested",
      "expert": "Ken D. Berry",
      "url": "https://drberry.com/blogs/news/7-health-tips-for-you-and-your-family"
    },
    {
      "do": "Get support as the caregiver, not only for the patient",
      "image": "/images/practices/bjmiller--bjm-caregiver-too.webp?v=da5fd7a1",
      "chip": "Expert viewpoint",
      "expert": "BJ Miller",
      "url": "https://www.mettlehealth.com/common-questions"
    },
    {
      "do": "Host something without cleaning up for it",
      "image": "/images/practices/bowler--kb-host-low-bar.webp?v=2a6955bb",
      "chip": "Expert viewpoint",
      "expert": "Kate Bowler",
      "url": "https://katebowler.substack.com/p/is-everyone-hanging-out-with-you"
    },
    {
      "do": "If cycling is your main activity, add weight-bearing impact for your bones",
      "image": "/images/practices/bowman--bow-bone-cyclists.webp?v=13ee07ae",
      "chip": "Emerging",
      "expert": "Katy Bowman",
      "url": "https://share.transistor.fm/s/93079f80"
    },
    {
      "do": "If you snore or have sleep apnea, keep alcohol away from bedtime",
      "image": "/images/practices/breus--brs-alcohol-apnea.webp?v=a448a5e0",
      "chip": "Established",
      "expert": "Michael J. Breus",
      "url": "https://sleepdoctor.com/pages/health/alcohol-and-sleep"
    },
    {
      "do": "Pay attention during the habit, not before it and not after it",
      "image": "/images/practices/brewer--bre-attend-during.webp?v=86707c8e",
      "chip": "Expert viewpoint",
      "expert": "Judson Brewer",
      "url": "https://drjud.com/behavior-change/reward-based-learning/"
    },
    {
      "do": "Fix one bedtime and keep it, including weekends",
      "image": "/images/practices/bryan-johnson--bjo-bedtime.webp?v=1d016b2c",
      "chip": "Established",
      "expert": "Bryan Johnson",
      "url": "https://protocol.bryanjohnson.com/"
    },
    {
      "do": "If you already hold a faith, attend services about four times a month",
      "image": "/images/practices/buettner--bu-belong.webp?v=93e7f229",
      "chip": "Contested",
      "expert": "Dan Buettner",
      "url": "https://www.bluezones.com/2016/11/power-9/"
    },
    {
      "do": "Get morning sunlight, on the view that it supports gut serotonin as well as mood",
      "image": "/images/practices/bulsiewicz--bul-morning-light-gut.webp?v=92072e55",
      "chip": "Emerging",
      "expert": "Will Bulsiewicz",
      "url": "https://zoe.com/learn/brain-gut-mystery-ibs-dr-will-bulsiewicz"
    },
    {
      "do": "Brush gently twice daily with a soft-bristled brush",
      "image": "/images/practices/burhenne--bur-brush.webp?v=ede42f32",
      "chip": "Established",
      "expert": "Mark Burhenne",
      "url": "https://askthedentist.com/wp-content/uploads/2019/11/28-Day-Oral-Microbiome-Reset.pdf"
    },
    {
      "do": "Buy dried or frozen beans, or beans in glass jars, instead of canned",
      "image": "/images/practices/burkart--bur-cans-swap.webp?v=867edc0e",
      "chip": "Emerging",
      "expert": "Yvonne Burkart",
      "url": "https://dryvonneburkart.com/are-your-bpa-free-cans-and-plastic-containers-hurting-your-fertility/"
    },
    {
      "do": "Get 20 to 30 g of fiber a day from a variety of plant foods",
      "image": "/images/practices/carvalho--car-fiber.webp?v=b6afb4b2",
      "chip": "Established",
      "expert": "Gil Carvalho",
      "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified"
    },
    {
      "do": "Follow the DASH eating plan if you are working on blood pressure",
      "image": "/images/practices/cdc-prevention--cdc-dash.webp?v=1c6aa89f",
      "chip": "Established",
      "expert": "CDC Prevention Guidance",
      "url": "https://www.cdc.gov/salt/reduce-sodium-intake/index.html"
    },
    {
      "do": "Do resistance training rather than high-volume cardio when the goal is hormonal",
      "image": "/images/practices/chaffee--cha-lift-not-cardio.webp?v=7a96b546",
      "chip": "Contested",
      "expert": "Anthony Chaffee",
      "url": "https://dranthonychaffee.com/blog/optimizing-hormones-on-a-carnivore-diet"
    },
    {
      "do": "Run the 3 Ms first thing each morning: Mindfulness, Movement, Mindset",
      "image": "/images/practices/chatterjee--cha-3m.webp?v=a6b91528",
      "chip": "Expert viewpoint",
      "expert": "Rangan Chatterjee",
      "url": "https://drchatterjee.com/blog/my-morning-routine/"
    },
    {
      "do": "Join a group in which the behaviour you want is already the normal behaviour",
      "image": "/images/practices/clear--cle-group.webp?v=6b9e8be7",
      "chip": "Expert viewpoint",
      "expert": "James Clear",
      "url": "https://www.hubermanlab.com/episode/best-ways-to-build-better-habits-and-break-bad-ones-james-clear"
    },
    {
      "do": "Stop using air fresheners, plug-ins and aerosol sprays",
      "image": "/images/practices/cohen--coh-airfresh.webp?v=c7721997",
      "chip": "Emerging",
      "expert": "Aly Cohen",
      "url": "https://thesmarthuman.com/five-more-ways-to-reduce-your-exposure-to-harmful-chemicals/"
    },
    {
      "do": "Take a brisk 10 to 20 minute walk after a large meal",
      "image": "/images/practices/dagostino--dag-walk-meal.webp?v=d00323cb",
      "chip": "Established",
      "expert": "Dominic P. D'Agostino",
      "url": "https://tim.blog/2026/01/06/ketosis-practical-guide-dom-dagostino/"
    },
    {
      "do": "Eat 35 to 60 or more grams of fibre a day from a variety of fibre-rich foods",
      "image": "/images/practices/davis--dav-fiber-35.webp?v=d6da9c30",
      "chip": "Established",
      "expert": "Brenda Davis",
      "url": "https://brendadavisrd.com/optimal-eating-guidelines/"
    },
    {
      "do": "Drink less alcohol or none",
      "image": "/images/practices/dietary-guidelines-americans--dga-alcohol.webp?v=c790f1c8",
      "chip": "Established",
      "expert": "Dietary Guidelines for Americans",
      "url": "https://cdn.realfood.gov/DGA.pdf"
    },
    {
      "do": "Dry wet materials quickly and remove materials that cannot be adequately dried",
      "image": "/images/practices/epa-indoor-air--epa-dry-materials.webp?v=de8da043",
      "chip": "Established",
      "expert": "EPA Indoor Air Quality",
      "url": "https://www.epa.gov/indoor-air-quality-iaq/what-can-i-do-improve-indoor-air-quality-my-home"
    },
    {
      "do": "Cook foods to a safe internal temperature and verify it with a food thermometer",
      "image": "/images/practices/fda-food-safety--fda-cook.webp?v=642ba55a",
      "chip": "Established",
      "expert": "FDA Consumer Food Safety",
      "url": "https://www.fda.gov/consumers/womens-health-topics/food-safety-home"
    },
    {
      "do": "Eat beans or lentils at both lunch and dinner, even a couple of tablespoons",
      "image": "/images/practices/fuhrman--fuh-beans.webp?v=c9f426d8",
      "chip": "Established",
      "expert": "Joel H. Fuhrman",
      "url": "https://www.drfuhrman.com/podcast/20/14-habits"
    },
    {
      "do": "Eat one very large mixed salad a day, built as a meal rather than as a side",
      "image": "/images/practices/fullyrawkristina--fkr-bigsalad.webp?v=b93dd425",
      "chip": "Established",
      "expert": "Kristina Carrillo-Bucaram",
      "url": "https://www.fullyraw.com/blog/5-reasons-why-you-don%E2%80%99t-enjoy-your-salads-&-how-to-change-it"
    },
    {
      "do": "Run at most two physical goals at once, and check they do not fight each other",
      "image": "/images/practices/galpin--gal-goal-count.webp?v=0cb06c82",
      "chip": "Expert viewpoint",
      "expert": "Andy Galpin",
      "url": "https://www.hubermanlab.com/episode/dr-andy-galpin-optimize-your-training-program-for-fitness-and-longevity"
    },
    {
      "do": "Remove all added oils from your food, including olive oil",
      "image": "/images/practices/goldner--gol-no-added-oil.webp?v=89026407",
      "chip": "Contested",
      "expert": "Brooke Goldner",
      "url": "https://nutritionstudies.org/healing-autoimmune-disease-with-supermarket-foods/"
    },
    {
      "do": "Support regulation of these chemicals where you can",
      "image": "/images/practices/gomberg--gom-advocacy.webp?v=ef7cb152",
      "chip": "Expert viewpoint",
      "expert": "Beatrice Gomberg",
      "url": "https://taborplace.co/blogs/plastic-is-toxic/freshwater-fish-and-pfas"
    },
    {
      "do": "Use halogen and incandescent bulbs at home in the evening and remove the dimmers",
      "image": "/images/practices/greenfield--bgr-bulbs.webp?v=85c2e504",
      "chip": "Contested",
      "expert": "Ben Greenfield",
      "url": "https://bengreenfieldlife.com/article/biohacking-articles/ben-greenfields-morning-afternoon-evening-routines/"
    },
    {
      "do": "Take 2,000 mcg of cyanocobalamin once a week, or 50 mcg daily",
      "image": "/images/practices/greger--gre-b12-weekly.webp?v=8e064d06",
      "chip": "Established",
      "expert": "Michael Greger",
      "url": "https://nutritionfacts.org/video/how-much-vitamin-b12-do-we-need-each-day/"
    },
    {
      "do": "If you lift weights, take 3 to 5 g of creatine a day",
      "image": "/images/practices/guess--gue-creatine-3to5g.webp?v=307f0e8b",
      "chip": "Established",
      "expert": "Nicola Guess",
      "url": "https://drguess.substack.com/p/creatine-for-brawn-and-brains"
    },
    {
      "do": "Write a family technology plan before giving a child a smartphone",
      "image": "/images/practices/haidt--hai-familyplan.webp?v=e88b8b6c",
      "chip": "Expert viewpoint",
      "expert": "Jonathan Haidt",
      "url": "https://www.afterbabel.com/p/taking-back-childhood"
    },
    {
      "do": "When you have a problem, tell someone. Do not carry it alone.",
      "image": "/images/practices/harris--har-neverworryalone.webp?v=d6d18c5d",
      "chip": "Emerging",
      "expert": "Dan Harris",
      "url": "https://danharris.substack.com/p/never-worry-alone-20a"
    },
    {
      "do": "Eat inside a window shorter than 10 hours",
      "image": "/images/practices/hill--hil-eating-window.webp?v=658de871",
      "chip": "Emerging",
      "expert": "Simon Hill",
      "url": "https://theproof.com/circadian-rhythm-eating-protocol/"
    },
    {
      "do": "Stop caffeine 8 to 10 hours before your bedtime",
      "image": "/images/practices/huberman--hub-caffeine-cutoff.webp?v=e85898b2",
      "chip": "Established",
      "expert": "Andrew D. Huberman",
      "url": "https://www.hubermanlab.com/newsletter/toolkit-for-sleep"
    },
    {
      "do": "Take 2,000 to 5,000 IU of vitamin D3 a day, combined with vitamin K2",
      "image": "/images/practices/hyman--hym-d3k2.webp?v=e6281da9",
      "chip": "Contested",
      "expert": "Mark Hyman",
      "url": "https://drhyman.com/blogs/content/are-your-bones-aging-faster-than-you-are-here-s-why-it-matters"
    },
    {
      "do": "Use your muscles for about 10 minutes within 90 minutes of finishing a meal",
      "image": "/images/practices/inchauspe--inc-move-after-eating.webp?v=d68ee841",
      "chip": "Established",
      "expert": "Jessie Inchauspé",
      "url": "https://www.glucosegoddess.com/pages/science-episode-the-10-glucose-goddess-hacks"
    },
    {
      "do": "Cover each muscle from more than one angle every week",
      "image": "/images/practices/israetel--isr-chest-mix.webp?v=4c204152",
      "chip": "Expert viewpoint",
      "expert": "Mike Israetel",
      "url": "https://rpstrength.com/blogs/articles/chest-hypertrophy-training-tips"
    },
    {
      "do": "Get outdoor light early in the day after a clock change",
      "image": "/images/practices/jetelina--jet-daylight.webp?v=bae69008",
      "chip": "Established",
      "expert": "Katelyn Jetelina",
      "url": "https://yourlocalepidemiologist.substack.com/p/daylight-saving-time-change-impact-jetelina"
    },
    {
      "do": "Keep a sleep routine, and look honestly at what alcohol is doing to it",
      "image": "/images/practices/kaeberlein--kae-sleep.webp?v=8249854b",
      "chip": "Established",
      "expert": "Matt Kaeberlein",
      "url": "https://podcasters.spotify.com/pod/show/the-optispan-podcast-with/episodes/Everything-I-do-for-Healthspan-and-why-I-skip-THESE-Supplements-e3dbv47"
    },
    {
      "do": "Average at least seven hours of sleep a night",
      "image": "/images/practices/kahn--kah-sleep-seven.webp?v=257e4f5f",
      "chip": "Established",
      "expert": "Joel Kahn",
      "url": "https://www.kahnlongevitycenter.com/blog/want-to-live-longer-get-adequate-sleep"
    },
    {
      "do": "Do not buy a stem cell treatment for autism",
      "image": "/images/practices/knoepfler--kno-autism.webp?v=982edfec",
      "chip": "Established",
      "expert": "Paul Knoepfler",
      "url": "https://ipscell.com/2025/10/stem-cell-therapy-cost-goes-up-what-to-consider-looking-ahead/"
    },
    {
      "do": "Replace disposable plastic cutlery with reusable or bamboo alternatives",
      "image": "/images/practices/lanphear--lan-bamboo.webp?v=f3c13664",
      "chip": "Emerging",
      "expert": "Bruce Lanphear",
      "url": "https://littlethingsmatter.ca/toxic/phthalates/"
    },
    {
      "do": "Arrange to exercise with someone else so that not showing up would let them down",
      "image": "/images/practices/lieberman--lie-social-commitment.webp?v=599afeec",
      "chip": "Emerging",
      "expert": "Daniel E. Lieberman",
      "url": "https://www.mountsinai.org/about/newsroom/podcasts/road-resilience/archive/weirdos-guide"
    },
    {
      "do": "Eat breakfast, and do not delete it to lengthen a fast",
      "image": "/images/practices/longo--lon-breakfast.webp?v=cbe99e29",
      "chip": "Contested",
      "expert": "Valter Longo",
      "url": "https://www.fondazionevalterlongo.org/wp-content/uploads/2024/02/2024-01_fondazione-longo_digiuno-e-longevita-EN-libro.pdf"
    },
    {
      "do": "Cook it yourself and eat it with other people",
      "image": "/images/practices/lustig--lus-cooktogether.webp?v=f03701e0",
      "chip": "Expert viewpoint",
      "expert": "Robert H. Lustig",
      "url": "https://robertlustig.com/real-food/"
    },
    {
      "do": "Put 30 to 50 grams of protein into your first meal of the day",
      "image": "/images/practices/lyon--lyo-firstmeal.webp?v=2ea0d43e",
      "chip": "Emerging",
      "expert": "Gabrielle Lyon",
      "url": "https://drgabriellelyon.com/wp-content/uploads/2024/01/The-Lyon-Protocol-Dr.-Gabrielle-Lyon.pdf"
    },
    {
      "do": "Practice slow diaphragmatic breathing while letting the pelvic floor soften",
      "image": "/images/practices/malik--mal-breathe.webp?v=ce4455ba",
      "chip": "Emerging",
      "expert": "Rena Malik",
      "url": "https://newsletter.renamalikmd.com/p/is-your-bathroom-killing-sex"
    },
    {
      "do": "Write a minimum version of one routine for a low-capacity day",
      "image": "/images/practices/mccabe--mcc-bad-day.webp?v=1aeaf945",
      "chip": "Expert viewpoint",
      "expert": "Jessica McCabe",
      "url": "https://howtoadhdbook.com/"
    },
    {
      "do": "Spend time caring for someone else during a stressful stretch of life",
      "image": "/images/practices/mcgonigal--mcg-caring.webp?v=6dd6b3b3",
      "chip": "Contested",
      "expert": "Kelly McGonigal",
      "url": "https://singjupost.com/how-to-make-stress-your-friend-by-kelly-mcgonigal-full-transcript/"
    },
    {
      "do": "Avoid high-carbohydrate meals late in the evening",
      "image": "/images/practices/means--mea-latenight.webp?v=ee61ffe5",
      "chip": "Emerging",
      "expert": "Casey Means",
      "url": "https://www.levels.com/blog/9-essential-elements-of-metabolically-healthy-meals"
    },
    {
      "do": "Eat two to three servings a day of dairy, especially yogurt and cheese",
      "image": "/images/practices/mozaffarian--moz-dairy.webp?v=6ad2cd7f",
      "chip": "Contested",
      "expert": "Dariush Mozaffarian",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4814348/"
    },
    {
      "do": "As an adult, reduce sodium intake if it is above the 2,300 milligram CDRR level",
      "image": "/images/practices/national-academies-dri--dri-sodium.webp?v=251ee59d",
      "chip": "Established",
      "expert": "National Academies Dietary Reference Intakes",
      "url": "https://nap.nationalacademies.org/catalog/25353/dietary-reference-intakes-for-sodium-and-potassium"
    },
    {
      "do": "Eat less if you have a weight issue, and move more",
      "image": "/images/practices/nestle--nes-eatlessmovemore.webp?v=7dce4547",
      "chip": "Established",
      "expert": "Marion Nestle",
      "url": "https://www.foodpolitics.com/2007/06/basic-advice-eat-less-move-more/"
    },
    {
      "do": "Keep bedtime and wake time consistent and use a calming wind-down routine",
      "image": "/images/practices/nia-healthy-aging--nia-sleep-routine.webp?v=30253f75",
      "chip": "Established",
      "expert": "NIH National Institute on Aging: Healthy Aging",
      "url": "https://www.nia.nih.gov/health/sleep/good-nights-sleep"
    },
    {
      "do": "Track the behavior in a simple way and review what the record shows",
      "image": "/images/practices/nice-lifestyle-wellbeing--nice-monitor-feedback.webp?v=0853f2ea",
      "chip": "Established",
      "expert": "NICE Lifestyle and Wellbeing",
      "url": "https://www.nice.org.uk/guidance/ph49/chapter/Recommendations"
    },
    {
      "do": "Use percent Daily Value as a label reference, not a personalized prescription",
      "image": "/images/practices/nih-ods--ods-dv.webp?v=21cabbcc",
      "chip": "Established",
      "expert": "NIH Office of Dietary Supplements",
      "url": "https://ods.od.nih.gov/factsheets/WYNTK-Consumer/"
    },
    {
      "do": "Lose weight at about 0.5 to 0.7% of your bodyweight per week",
      "image": "/images/practices/nippard--nip-deficit-rate.webp?v=48c54686",
      "chip": "Established",
      "expert": "Jeff Nippard",
      "url": "https://www.youtube.com/watch?v=Cc97g7_CkQs"
    },
    {
      "do": "Ask what the studies that were not cited found",
      "image": "/images/practices/norton--nor-cherrypick.webp?v=9e2f92fa",
      "chip": "Expert viewpoint",
      "expert": "Layne Norton",
      "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/how-to-think-like-a-scientist-episode-8/"
    },
    {
      "do": "Buy fewer clothes, in natural or organic fibres, and keep them longer",
      "image": "/images/practices/olien--oli-clothes-organic.webp?v=5024925f",
      "chip": "Expert viewpoint",
      "expert": "Darin Olien",
      "url": "https://podcasts.happyscribe.com/the-darin-olien-show/37-fatal-conveniences-toxic-clothes-what-are-you-wearing"
    },
    {
      "do": "Put the phone in another room for one defined focus period",
      "image": "/images/practices/orben--orb-focus.webp?v=6ef53b52",
      "chip": "Established",
      "expert": "Amy Orben",
      "url": "https://www.cam.ac.uk/stories/socialmedia"
    },
    {
      "do": "Eat enough whole plant food that your fibre intake roughly doubles",
      "image": "/images/practices/ornish--orn-fiber.webp?v=14316bce",
      "chip": "Established",
      "expert": "Dean Michael Ornish",
      "url": "https://pubmed.ncbi.nlm.nih.gov/18237581/"
    },
    {
      "do": "Choose one valued activity as a functional recovery goal",
      "image": "/images/practices/osullivan--osu-goals.webp?v=171a3267",
      "chip": "Established",
      "expert": "Peter O'Sullivan",
      "url": "https://www.iasp-pain.org/publications/relief-news/article/cb-cft-back-pain/"
    },
    {
      "do": "Cut highly processed foods before considering any stricter dietary change",
      "image": "/images/practices/palmer--pal-processed-first.webp?v=706ef0b9",
      "chip": "Emerging",
      "expert": "Christopher M. Palmer",
      "url": "https://www.hubermanlab.com/episode/dr-chris-palmer-diet-nutrition-for-mental-health"
    },
    {
      "do": "Once you know your real window, pick one 10 to 11 hours long and hold it",
      "image": "/images/practices/panda--pan-cut1011.webp?v=86d93423",
      "chip": "Emerging",
      "expert": "Satchidananda Panda",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4635036/"
    },
    {
      "do": "Put a recurring check-in with someone you care about in both of your calendars",
      "image": "/images/practices/perel--per-checkins.webp?v=26d761db",
      "chip": "Expert viewpoint",
      "expert": "Esther Perel",
      "url": "https://estherperel.substack.com/p/coping-with-loneliness-around-the"
    },
    {
      "do": "Count short bouts of activity toward the weekly total",
      "image": "/images/practices/physical-activity-guidelines-americans--pag-any-counts.webp?v=00539ce5",
      "chip": "Established",
      "expert": "Physical Activity Guidelines for Americans",
      "url": "https://odphp.health.gov/our-work/nutrition-physical-activity/physical-activity-guidelines/current-guidelines/top-10-things-know"
    },
    {
      "do": "Spend time in green spaces rather than only outdoors",
      "image": "/images/practices/picard--pic-greenspace.webp?v=73cc8572",
      "chip": "Expert viewpoint",
      "expert": "Martin Picard",
      "url": "https://tseenergy.substack.com/p/sunlight-and-mitochondria"
    },
    {
      "do": "Put on amber or orange lenses in the evening if screens are staying on",
      "image": "/images/practices/pompa--pom-amber.webp?v=20dea75f",
      "chip": "Emerging",
      "expert": "Dr. Daniel Pompa",
      "url": "https://drpompa.com/health/exposing-the-dangers-of-blue-light/"
    },
    {
      "do": "Run a HEPA filter in the room you spend most time in",
      "image": "/images/practices/rhonda-patrick--rhp-mp-hepa.webp?v=9a631228",
      "chip": "Emerging",
      "expert": "Rhonda Patrick",
      "url": "https://www.foundmyfitness.com/episodes/microplastics"
    },
    {
      "do": "Add more plants to what you already eat, without trying to be perfect about it",
      "image": "/images/practices/richroll--rol-eat-more-plants.webp?v=6fb79c5c",
      "chip": "Expert viewpoint",
      "expert": "Rich Roll",
      "url": "https://richroll.com/blog/why-everyone-should-eat-more-plants/"
    },
    {
      "do": "Get a fasting insulin test, not just fasting glucose",
      "image": "/images/practices/saladino--sal-fasting-insulin.webp?v=c68f1a18",
      "chip": "Emerging",
      "expert": "Paul Gregory Saladino",
      "url": "https://www.paulsaladinomd.com/psmd-newsletters/better-than-trt-how-i-maintain-800-testosterone-at-48"
    },
    {
      "do": "Build one close friendship rather than more casual contact",
      "image": "/images/practices/santos--san-closefriend.webp?v=fcefcec6",
      "chip": "Established",
      "expert": "Laurie R. Santos",
      "url": "https://www.pushkin.fm/podcasts/the-happiness-lab-with-dr-laurie-santos/men-dont-just-need-friends-they-need-bromance"
    },
    {
      "do": "Do not take a full week off mid-programme expecting to come back bigger",
      "image": "/images/practices/schoenfeld--sch-deload-null.webp?v=6cf01fb1",
      "chip": "Emerging",
      "expert": "Brad Schoenfeld",
      "url": "https://pubmed.ncbi.nlm.nih.gov/38274324/"
    },
    {
      "do": "Cut down on drinking any beverage from a plastic bottle, including water",
      "image": "/images/practices/schwarcz--sch-bottledwater.webp?v=744a5e1d",
      "chip": "Expert viewpoint",
      "expert": "Joe Schwarcz",
      "url": "https://www.mcgill.ca/oss/article/health-and-nutrition-environment/oh-those-micro-and-nanoplastics"
    },
    {
      "do": "Keep long easy sessions in the plan and stop treating them as wasted time",
      "image": "/images/practices/seiler--sei-lit-not-wasted.webp?v=77009d26",
      "chip": "Established",
      "expert": "Stephen Seiler",
      "url": "https://www.sportsci.org/2009/ss.htm"
    },
    {
      "do": "If you cannot sleep at night, stop napping in the day",
      "image": "/images/practices/shelbyharris--sh-no-nap-if-insomnia.webp?v=371d87a2",
      "chip": "Established",
      "expert": "Shelby Harris",
      "url": "https://drshelbyharris.com/sleep-problems-adults/"
    },
    {
      "do": "Keep carbohydrates between 40 and 55 percent of your calories, from whole foods",
      "image": "/images/practices/siimland--sil-carbrange.webp?v=49304be0",
      "chip": "Contested",
      "expert": "Siim Land",
      "url": "https://www.siimland.co/my-longevity-routine"
    },
    {
      "do": "Use 2 to 3 mg of caffeine per kilogram of body weight before longer sessions",
      "image": "/images/practices/sims--sim-caffeine-dose.webp?v=70fa31f3",
      "chip": "Established",
      "expert": "Stacy T. Sims",
      "url": "https://www.drstacysims.com/newsletters/articles/posts/Sports_Supplements_What_Works_for_Women"
    },
    {
      "do": "Bank 75 minutes of vigorous exercise across the week",
      "image": "/images/practices/sinclair--sin-75min.webp?v=3f0ad542",
      "chip": "Established",
      "expert": "David A. Sinclair",
      "url": "https://www.lifespanpodcast.com/exercise-heat-cold-and-other-stressors-for-longevity/"
    },
    {
      "do": "Get your hearing tested, and treat hearing loss if you have it",
      "image": "/images/practices/starrett--str-hearing-dementia.webp?v=ce9690f7",
      "chip": "Emerging",
      "expert": "Kelly Starrett",
      "url": "https://thereadystate.com/trs_podcast/recess-200-episodes-dementia-risk/"
    },
    {
      "do": "Do not have more than two standard drinks on any single day",
      "image": "/images/practices/stockwell--sto-twoaday.webp?v=2d7aa2df",
      "chip": "Established",
      "expert": "Tim Stockwell",
      "url": "https://theconversation.com/canadas-low-risk-alcohol-use-guidelines-have-been-slashed-to-6-drinks-per-week-heres-why-189667"
    },
    {
      "do": "Buy unwrapped produce and refill your own glass container from bulk bins",
      "image": "/images/practices/swan--swa-bulk.webp?v=a45b7713",
      "chip": "Expert viewpoint",
      "expert": "Shanna H. Swan",
      "url": "https://www.hubermanlab.com/episode/dr-shanna-swan-how-to-safeguard-your-hormone-health-fertility"
    },
    {
      "do": "Drink two cups of soup broth a day when you start a low-carbohydrate diet",
      "image": "/images/practices/teicholz--tei-ketoflu-broth.webp?v=671991b8",
      "chip": "Expert viewpoint",
      "expert": "Nina Teicholz",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11944661/"
    },
    {
      "do": "Keep your sleep and wake times regular, not just your sleep duration",
      "image": "/images/practices/topol--top-sleep-regularity.webp?v=811d3096",
      "chip": "Emerging",
      "expert": "Eric Topol",
      "url": "https://erictopol.substack.com/p/matthew-walker-promoting-our-sleep"
    },
    {
      "do": "Raise plastic exposure at your child's next appointment",
      "image": "/images/practices/trasande--tra-clinician.webp?v=fff557d6",
      "chip": "Expert viewpoint",
      "expert": "Leonardo Trasande",
      "url": "https://pubmed.ncbi.nlm.nih.gov/40992383/"
    },
    {
      "do": "If screening finds prediabetes, ask about an effective preventive intervention",
      "image": "/images/practices/uspstf-recommendations--usp-prediabetes-referral.webp?v=99c69c89",
      "chip": "Established",
      "expert": "USPSTF Recommendations",
      "url": "https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/screening-for-prediabetes-and-type-2-diabetes"
    },
    {
      "do": "Express specific appreciation to someone while the relationship is active",
      "image": "/images/practices/waldinger--wal-appreciate.webp?v=b91d4639",
      "chip": "Expert viewpoint",
      "expert": "Robert Waldinger",
      "url": "https://www.robertwaldinger.com/harvard-study/"
    },
    {
      "do": "Do not treat six hours as enough",
      "image": "/images/practices/walker--wal-6h-insufficient.webp?v=cff4e6db",
      "chip": "Contested",
      "expert": "Matthew Walker",
      "url": "https://sleepdiplomat.wordpress.com/2019/12/19/why-we-sleep-responses-to-questions-from-readers/"
    },
    {
      "do": "Prefer unsaturated fats and avoid industrially produced trans fats",
      "image": "/images/practices/who-healthy-living--who-fat-quality.webp?v=443958fa",
      "chip": "Established",
      "expert": "WHO Healthy Living Guidance",
      "url": "https://www.who.int/news-room/fact-sheets/detail/healthy-diet"
    },
    {
      "do": "Let sunscreen dry before you dress or go outside, whichever filter type it uses",
      "image": "/images/practices/wong--won-drydown.webp?v=17809a1f",
      "chip": "Expert viewpoint",
      "expert": "Michelle Wong",
      "url": "https://labmuffin.com/need-apply-sunscreen-sun-exposure/"
    },
    {
      "do": "Let your sleep change shape as you age instead of trying to restore it",
      "image": "/images/practices/wu--wu-aging-sleep-ok.webp?v=3be569c0",
      "chip": "Established",
      "expert": "Jade Wu",
      "url": "https://www.drjadewu.com/resources"
    },
    {
      "do": "Build meals around protein, aiming for at least 16 per cent of your daily intake",
      "image": "/images/practices/yeo--yeo-protein-satiety.webp?v=c6196635",
      "chip": "Established",
      "expert": "Giles Yeo",
      "url": "https://www.sciencefocus.com/the-human-body/3-dieting-rules"
    },
    {
      "do": "Eat regular, adequate meals, and do not expect any one diet to cure pain",
      "image": "/images/practices/zoffness--zof-nutrition.webp?v=1b6419b7",
      "chip": "Expert viewpoint",
      "expert": "Rachel Zoffness",
      "url": "https://www.zoffness.com/books/pain-management-workbook"
    },
    {
      "do": "See a dentist on a schedule personalized to oral-health risk and needs",
      "image": "/images/practices/ada-mouthhealthy--ada-dentist.webp?v=478f202f",
      "chip": "Established",
      "expert": "ADA MouthHealthy",
      "url": "https://www.mouthhealthy.org/oral-health-recommendations"
    },
    {
      "do": "Buy organic staples at a warehouse club if the price is the obstacle",
      "image": "/images/practices/adler--adl-costco.webp?v=ea2ac191",
      "chip": "Expert viewpoint",
      "expert": "Lara Adler",
      "url": "https://theenergyblueprint.com/laraadler/"
    },
    {
      "do": "Reduce long periods of sitting by adding short movement breaks during the day",
      "image": "/images/practices/aha-lifes-essential-8--aha-break-sitting.webp?v=aa3ff301",
      "chip": "Established",
      "expert": "American Heart Association Life's Essential 8",
      "url": "https://www.heart.org/en/healthy-living/healthy-lifestyle/lifes-essential-8/how-to-be-more-active-fact-sheet"
    },
    {
      "do": "Avoid tobacco and seek help to quit if you use it",
      "image": "/images/practices/american-cancer-society-prevention--acs-no-tobacco.webp?v=0ad4e8d9",
      "chip": "Established",
      "expert": "American Cancer Society Prevention and Screening",
      "url": "https://www.cancer.org/cancer/risk-prevention.html"
    },
    {
      "do": "Take 3 to 5 g of creatine monohydrate a day",
      "image": "/images/practices/aragon--ara-creatine.webp?v=765bbc4c",
      "chip": "Established",
      "expert": "Alan Aragon",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8471721/"
    },
    {
      "do": "Find a practitioner to teach you stability work, and expect to try more than one",
      "image": "/images/practices/attia--att-stability-coach.webp?v=5e78ec5e",
      "chip": "Expert viewpoint",
      "expert": "Peter Attia",
      "url": "https://peterattiamd.com/peter-on-stability-the-foundation-of-the-4-exercise-components/"
    },
    {
      "do": "Seek a comprehensive ADHD evaluation when symptoms cause persistent impairment",
      "image": "/images/practices/barkley--bar-evaluation.webp?v=a4e890d4",
      "chip": "Established",
      "expert": "Russell Barkley",
      "url": "https://www.guilford.com/books/Taking-Charge-of-Adult-ADHD/Russell-Barkley/9781462546855/contents"
    },
    {
      "do": "Aim for about 40 grams of fibre a day",
      "image": "/images/practices/barnard--bar-fibre-40.webp?v=bd668d3b",
      "chip": "Established",
      "expert": "Neal Barnard",
      "url": "https://www.pcrm.org/health-topics/diabetes"
    },
    {
      "do": "Go for a walk outside in the morning",
      "image": "/images/practices/berry--ber-morningwalk.webp?v=20be4c62",
      "chip": "Established",
      "expert": "Ken D. Berry",
      "url": "https://drberry.com/blogs/news/7-health-tips-for-you-and-your-family"
    },
    {
      "do": "Let yourself be helped, and stop treating needing people as a failure",
      "image": "/images/practices/bjmiller--bjm-interdependence.webp?v=21ac84cd",
      "chip": "Expert viewpoint",
      "expert": "BJ Miller",
      "url": "https://tricycle.org/podcast/bj-miller/"
    },
    {
      "do": "Leave the house for one thing you would normally do at home this week",
      "image": "/images/practices/bowler--kb-leave-house.webp?v=51d2f114",
      "chip": "Expert viewpoint",
      "expert": "Kate Bowler",
      "url": "https://katebowler.substack.com/p/is-everyone-hanging-out-with-you"
    },
    {
      "do": "Change the shape you are sitting in, not just how long you sit",
      "image": "/images/practices/bowman--bow-change-position.webp?v=c32f38d9",
      "chip": "Expert viewpoint",
      "expert": "Katy Bowman",
      "url": "https://podcasts.apple.com/us/podcast/ep-168-is-sitting-aging-you-faster/id894200695?i=1000677606358"
    },
    {
      "do": "If you are a bear, hold your first coffee until 9:30am",
      "image": "/images/practices/breus--brs-bear-coffee.webp?v=f217e5eb",
      "chip": "Emerging",
      "expert": "Michael J. Breus",
      "url": "https://sleepdoctor.com/pages/chronotypes/bear-chronotype"
    },
    {
      "do": "Write down the loop: what triggered it, what you did, and what you got out of it",
      "image": "/images/practices/brewer--bre-map.webp?v=9c9612cb",
      "chip": "Expert viewpoint",
      "expert": "Judson Brewer",
      "url": "https://drjud.com/a-simple-way-to-break-bad-habits/"
    },
    {
      "do": "Take your last caffeine eight to ten hours before you sleep",
      "image": "/images/practices/bryan-johnson--bjo-caffeine.webp?v=951460b1",
      "chip": "Established",
      "expert": "Bryan Johnson",
      "url": "https://protocol.bryanjohnson.com/"
    },
    {
      "do": "Buy only sourdough or 100 percent whole wheat bread",
      "image": "/images/practices/buettner--bu-bread.webp?v=7f251fc9",
      "chip": "Emerging",
      "expert": "Dan Buettner",
      "url": "https://www.bluezones.com/recipes/food-guidelines/"
    },
    {
      "do": "Clean the tongue gently without scraping to the point of pain or bleeding",
      "image": "/images/practices/burhenne--bur-tongue.webp?v=272135da",
      "chip": "Established",
      "expert": "Mark Burhenne",
      "url": "https://askthedentist.com/tongue-scraper-cleaning-tongue/"
    },
    {
      "do": "Skip detox teas, juice cleanses and liver-support supplements",
      "image": "/images/practices/burkart--bur-detox-nocleanse.webp?v=122fa03e",
      "chip": "Established",
      "expert": "Yvonne Burkart",
      "url": "https://dryvonneburkart.com/the-truth-about-detox-how-to-boost-your-bodys-natural-defenses-for-lifelong-health/"
    },
    {
      "do": "Add resistance training to your cardio rather than choosing between them",
      "image": "/images/practices/carvalho--car-resistance-add.webp?v=761cbf4e",
      "chip": "Established",
      "expert": "Gil Carvalho",
      "url": "https://podcast.clearerthinking.org/episode/212/gil-carvalho-what-we-know-and-don-t-know-about-nutrition/"
    },
    {
      "do": "Record major family health history and share it during preventive care",
      "image": "/images/practices/cdc-prevention--cdc-family-history.webp?v=f56c7bb9",
      "chip": "Established",
      "expert": "CDC Prevention Guidance",
      "url": "https://www.cdc.gov/chronic-disease/prevention/index.html"
    },
    {
      "do": "Add grass-fed tallow, butter, ghee or lamb fat to every meal",
      "image": "/images/practices/chaffee--cha-ms-grassfed-fat.webp?v=8d487383",
      "chip": "Emerging",
      "expert": "Anthony Chaffee",
      "url": "https://dranthonychaffee.com/blog/dr-chaffees-protocol-for-optimizing-multiple-sclerosis-recovery"
    },
    {
      "do": "Take a deliberate month off alcohol and record what changes",
      "image": "/images/practices/chatterjee--cha-alcoholbreak.webp?v=78160dc6",
      "chip": "Expert viewpoint",
      "expert": "Rangan Chatterjee",
      "url": "https://drchatterjee.com/blog/why-wait-for-dry-january-heres-why-the-right-time-for-a-break-from-alcohol-is-now/"
    },
    {
      "do": "Never miss twice: if you miss a day, do the smallest version the next day",
      "image": "/images/practices/clear--cle-nevermiss.webp?v=34c122cd",
      "chip": "Expert viewpoint",
      "expert": "James Clear",
      "url": "https://jamesclear.com/habit-tracker"
    },
    {
      "do": "Check AirNow.gov before you plan time outdoors",
      "image": "/images/practices/cohen--coh-airnow.webp?v=b6d6ee2d",
      "chip": "Established",
      "expert": "Aly Cohen",
      "url": "https://www.mariashriversundaypaper.com/toxins-aly-cohen/"
    },
    {
      "do": "Choose intact and cut grains over flours, flakes and puffed grains",
      "image": "/images/practices/davis--dav-intact-grains.webp?v=b2916957",
      "chip": "Established",
      "expert": "Brenda Davis",
      "url": "https://brendadavisrd.com/whole-grains/"
    },
    {
      "do": "Choose whole fruit more often than juice",
      "image": "/images/practices/dietary-guidelines-americans--dga-fruit.webp?v=82402cd7",
      "chip": "Established",
      "expert": "Dietary Guidelines for Americans",
      "url": "https://cdn.realfood.gov/DGA.pdf"
    },
    {
      "do": "Use filtration as a supplement to source control and ventilation",
      "image": "/images/practices/epa-indoor-air--epa-filtration-supplement.webp?v=20f6e308",
      "chip": "Established",
      "expert": "EPA Indoor Air Quality",
      "url": "https://www.epa.gov/indoor-air-quality-iaq/air-cleaners-and-air-filters-home"
    },
    {
      "do": "Keep the freezer at 0°F",
      "image": "/images/practices/fda-food-safety--fda-freezer.webp?v=59a84889",
      "chip": "Established",
      "expert": "FDA Consumer Food Safety",
      "url": "https://www.fda.gov/consumers/consumer-updates/are-you-storing-food-safely"
    },
    {
      "do": "Chew each mouthful until it fully liquefies before swallowing",
      "image": "/images/practices/fuhrman--fuh-chew.webp?v=a55b9c42",
      "chip": "Expert viewpoint",
      "expert": "Joel H. Fuhrman",
      "url": "https://www.drfuhrman.com/podcast/20/14-habits"
    },
    {
      "do": "Run the day as juice for breakfast, smoothie for lunch, salad for dinner",
      "image": "/images/practices/fullyrawkristina--fkr-jss.webp?v=96999060",
      "chip": "Expert viewpoint",
      "expert": "Kristina Carrillo-Bucaram",
      "url": "https://www.fullyraw.com/blog/how-to-eat-a-raw-vegan-diet-naturally-easy-recipes-tips-for-beginners"
    },
    {
      "do": "Eat predominantly raw for a 4 to 6 week recovery phase, then reassess",
      "image": "/images/practices/goldner--gol-raw-recovery-phase.webp?v=440f63c7",
      "chip": "Expert viewpoint",
      "expert": "Brooke Goldner",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10949923/"
    },
    {
      "do": "Open a window for ten minutes and damp-dust one room",
      "image": "/images/practices/gomberg--gom-air.webp?v=9ec8af7c",
      "chip": "Emerging",
      "expert": "Beatrice Gomberg",
      "url": "https://taborplace.co/blogs/plastic-is-toxic/are-microplastics-the-lead-of-our-generation-10-ways-to-avoid-microplastics"
    },
    {
      "do": "Take 5 grams of creatine monohydrate every morning",
      "image": "/images/practices/greenfield--bgr-creatine.webp?v=9d2e594a",
      "chip": "Established",
      "expert": "Ben Greenfield",
      "url": "https://bengreenfieldlife.com/article/supplements-articles/ben-greenfields-ultimate-supplement-guide/"
    },
    {
      "do": "Add two servings of beans, lentils, chickpeas, or split peas a day to lower LDL",
      "image": "/images/practices/greger--gre-beans-cholesterol.webp?v=0d44beab",
      "chip": "Established",
      "expert": "Michael Greger",
      "url": "https://nutritionfacts.org/video/beans-beans-theyre-good-for-your-heart/"
    },
    {
      "do": "Make half of your lunch and dinner plate fresh vegetables, salad or legumes",
      "image": "/images/practices/guess--gue-half-plate-veg.webp?v=d9979099",
      "chip": "Established",
      "expert": "Nicola Guess",
      "url": "https://drguess.substack.com/p/upfs-practical-tips"
    },
    {
      "do": "Choose one recurring family period, such as dinner, that stays device-free",
      "image": "/images/practices/haidt--hai-meals.webp?v=80d2f0a4",
      "chip": "Established",
      "expert": "Jonathan Haidt",
      "url": "https://www.anxiousgeneration.com/"
    },
    {
      "do": "Tell yourself that rest is still useful even if sleep does not come",
      "image": "/images/practices/harris--har-night-accept.webp?v=4b6aa1d4",
      "chip": "Expert viewpoint",
      "expert": "Dan Harris",
      "url": "https://danharris.substack.com/p/what-to-do-when-its-the-middle-of"
    },
    {
      "do": "Eat fermented foods every day",
      "image": "/images/practices/hill--hil-ferments.webp?v=da0778b5",
      "chip": "Emerging",
      "expert": "Simon Hill",
      "url": "https://theproof.com/microbiome-diversity-protocol/"
    },
    {
      "do": "Sleep in a cool, dark room and layer blankets you can throw off",
      "image": "/images/practices/huberman--hub-cool-dark-room.webp?v=755d24b8",
      "chip": "Established",
      "expert": "Andrew D. Huberman",
      "url": "https://www.hubermanlab.com/newsletter/toolkit-for-sleep"
    },
    {
      "do": "Take your headphones off and give your ears a quiet break at least once an hour",
      "image": "/images/practices/hyman--hym-ear-break.webp?v=98e53273",
      "chip": "Expert viewpoint",
      "expert": "Mark Hyman",
      "url": "https://drhyman.com/blogs/content/can-hearing-aids-slow-brain-aging-the-hidden-risks-of-hearing-loss"
    },
    {
      "do": "If you snack between meals, make the snack savoury rather than sweet",
      "image": "/images/practices/inchauspe--inc-savoury-snack.webp?v=33e48b21",
      "chip": "Expert viewpoint",
      "expert": "Jessie Inchauspé",
      "url": "https://www.glucosegoddess.com/pages/science-episode-the-10-glucose-goddess-hacks"
    },
    {
      "do": "Do not take a week off mid-programme just because the calendar says so",
      "image": "/images/practices/israetel--isr-deload-null.webp?v=e762ff6e",
      "chip": "Contested",
      "expert": "Mike Israetel",
      "url": "https://pubmed.ncbi.nlm.nih.gov/38274324/"
    },
    {
      "do": "Avoid shredded iceberg lettuce while the cyclosporiasis recall covers your state",
      "image": "/images/practices/jetelina--jet-lettuce-iceberg.webp?v=249f0e0f",
      "chip": "Expert viewpoint",
      "expert": "Katelyn Jetelina",
      "url": "https://yourlocalepidemiologist.substack.com/p/bad-air-bad-lettuce"
    },
    {
      "do": "Discount a cord blood bank's autism claim",
      "image": "/images/practices/knoepfler--kno-bankautism.webp?v=fa410064",
      "chip": "Established",
      "expert": "Paul Knoepfler",
      "url": "https://ipscell.com/2021/01/fact-checking-pros-and-cons-of-cord-blood-banking/"
    },
    {
      "do": "Limit large predatory fish",
      "image": "/images/practices/lanphear--lan-bigfish.webp?v=8f6cae03",
      "chip": "Established",
      "expert": "Bruce Lanphear",
      "url": "https://littlethingsmatter.ca/toxic/pfas-2/"
    },
    {
      "do": "Get 2.5 to 5 hours of exercise a week, with some of it vigorous",
      "image": "/images/practices/longo--lon-exdose.webp?v=8794e146",
      "chip": "Established",
      "expert": "Valter Longo",
      "url": "https://valterlongo.com/exercise-and-longevity/"
    },
    {
      "do": "Eat real food, and let the rest take care of itself",
      "image": "/images/practices/lustig--lus-eatrealfood.webp?v=2d017208",
      "chip": "Expert viewpoint",
      "expert": "Robert H. Lustig",
      "url": "https://robertlustig.com/real-food/"
    },
    {
      "do": "Build three meals a day, each with at least 30 grams of high quality protein",
      "image": "/images/practices/lyon--lyo-meal-30.webp?v=b022cc2c",
      "chip": "Emerging",
      "expert": "Gabrielle Lyon",
      "url": "https://drgabriellelyon.com/wp-content/uploads/2024/01/The-Lyon-Protocol-Dr.-Gabrielle-Lyon.pdf"
    },
    {
      "do": "Tell your partner what feels good, what does not and what context helps",
      "image": "/images/practices/malik--mal-communicate.webp?v=fe03a5e8",
      "chip": "Expert viewpoint",
      "expert": "Rena Malik",
      "url": "https://newsletter.renamalikmd.com/p/is-your-bathroom-killing-sex"
    },
    {
      "do": "List the immediate and delayed benefits and costs of a difficult change",
      "image": "/images/practices/mccabe--mcc-decision-balance.webp?v=59a1463d",
      "chip": "Established",
      "expert": "Jessica McCabe",
      "url": "https://howtoadhdbook.com/resources/"
    },
    {
      "do": "Once a day, thank your past self for something it did for you",
      "image": "/images/practices/mcgonigal--mcg-futureself.webp?v=6d78205d",
      "chip": "Expert viewpoint",
      "expert": "Kelly McGonigal",
      "url": "https://soundstrue.com/a/resources/transcript/kelly-mcgonigal-cultivating-positive-change/"
    },
    {
      "do": "Break up sitting with two minutes of light movement every 30 minutes",
      "image": "/images/practices/means--mea-move30.webp?v=a9c4486f",
      "chip": "Emerging",
      "expert": "Casey Means",
      "url": "https://www.hubermanlab.com/episode/dr-casey-means-transform-your-health-by-improving-metabolism-hormone-blood-sugar-regulation"
    },
    {
      "do": "Eat fish or shellfish at least twice a week",
      "image": "/images/practices/mozaffarian--moz-fish.webp?v=519f1523",
      "chip": "Established",
      "expert": "Dariush Mozaffarian",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4814348/"
    },
    {
      "do": "Treat the Tolerable Upper Intake Level as a safety boundary, not an intake goal",
      "image": "/images/practices/national-academies-dri--dri-ul.webp?v=314e6ca2",
      "chip": "Established",
      "expert": "National Academies Dietary Reference Intakes",
      "url": "https://nap.nationalacademies.org/catalog/11537/dietary-reference-intakes-the-essential-guide-to-nutrient-requirements"
    },
    {
      "do": "Skip packaged foods with more than five ingredients",
      "image": "/images/practices/nestle--nes-fiveingredients.webp?v=0a10f307",
      "chip": "Expert viewpoint",
      "expert": "Marion Nestle",
      "url": "https://www.foodpolitics.com/2010/12/latest-san-francisco-chronicle-column-processed-v-real-foods/"
    },
    {
      "do": "Schedule regular contact or shared activity with people who matter to you",
      "image": "/images/practices/nia-healthy-aging--nia-social-connection.webp?v=a6284534",
      "chip": "Emerging",
      "expert": "NIH National Institute on Aging: Healthy Aging",
      "url": "https://www.nia.nih.gov/health/healthy-aging/what-do-we-know-about-healthy-aging"
    },
    {
      "do": "Set a realistic goal and write down when, where, and how you will act",
      "image": "/images/practices/nice-lifestyle-wellbeing--nice-shared-goal-plan.webp?v=9d08ea9f",
      "chip": "Established",
      "expert": "NICE Lifestyle and Wellbeing",
      "url": "https://www.nice.org.uk/guidance/ph49/chapter/Recommendations"
    },
    {
      "do": "Meet nutrient needs primarily through a varied eating pattern when possible",
      "image": "/images/practices/nih-ods--ods-food-first.webp?v=b619a9b8",
      "chip": "Established",
      "expert": "NIH Office of Dietary Supplements",
      "url": "https://ods.od.nih.gov/factsheets/WYNTK-Consumer/"
    },
    {
      "do": "Take your sets close to failure instead of adding more easy sets",
      "image": "/images/practices/nippard--nip-effort.webp?v=f5ed7d9f",
      "chip": "Established",
      "expert": "Jeff Nippard",
      "url": "https://www.youtube.com/watch?v=HimT73spWQ4"
    },
    {
      "do": "Ask who a study was done in before applying it to yourself",
      "image": "/images/practices/norton--nor-context-studies.webp?v=30b7b08d",
      "chip": "Expert viewpoint",
      "expert": "Layne Norton",
      "url": "https://peterattiamd.com/laynenorton/"
    },
    {
      "do": "Avoid personal care products whose label says only fragrance or parfum",
      "image": "/images/practices/olien--oli-cond-fragrance.webp?v=426ec421",
      "chip": "Established",
      "expert": "Darin Olien",
      "url": "https://podcasts.happyscribe.com/the-darin-olien-show/25-fatal-conveniences-hair-conditioner-smooth-silky-at-what-cost"
    },
    {
      "do": "Ask whether a digital environment supports autonomy, competence, and relatedness",
      "image": "/images/practices/orben--orb-need.webp?v=2fa38bdc",
      "chip": "Emerging",
      "expert": "Amy Orben",
      "url": "https://www.nature.com/articles/s41562-025-02167-9"
    },
    {
      "do": "Do mild strength training at least three times a week",
      "image": "/images/practices/ornish--orn-strength3.webp?v=5ea9f64c",
      "chip": "Established",
      "expert": "Dean Michael Ornish",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11157928/"
    },
    {
      "do": "Address a persistent sleep barrier as part of the back-pain plan",
      "image": "/images/practices/osullivan--osu-sleep.webp?v=9a73510d",
      "chip": "Established",
      "expert": "Peter O'Sullivan",
      "url": "https://www.iasp-pain.org/wp-content/uploads/2024/06/cognitive-functional-therapy-msk-fact-sheet_R1.pdf"
    },
    {
      "do": "Get at least seven hours of sleep a night",
      "image": "/images/practices/palmer--pal-sleep7.webp?v=8423a749",
      "chip": "Established",
      "expert": "Christopher M. Palmer",
      "url": "https://www.cnbc.com/2022/12/16/harvard-brain-expert-shares-what-he-never-does-in-order-to-stay-sharp-energized-healthy.html"
    },
    {
      "do": "Dim the lights at home in the evening",
      "image": "/images/practices/panda--pan-dimevening.webp?v=24bc66a1",
      "chip": "Established",
      "expert": "Satchidananda Panda",
      "url": "https://www.foundmyfitness.com/episodes/satchin-panda-3"
    },
    {
      "do": "Work out what kind of fighter you are and how you like to make up",
      "image": "/images/practices/perel--per-fighterlens.webp?v=f08a244d",
      "chip": "Expert viewpoint",
      "expert": "Esther Perel",
      "url": "https://www.estherperel.com/blog/letters-from-esther-44-what-does-repair-look-like-in-relationships"
    },
    {
      "do": "Include vigorous activity on at least three days weekly for ages 6 to 17",
      "image": "/images/practices/physical-activity-guidelines-americans--pag-child-vigorous.webp?v=d598067a",
      "chip": "Established",
      "expert": "Physical Activity Guidelines for Americans",
      "url": "https://health.gov/sites/default/files/2019-09/Physical_Activity_Guidelines_2nd_edition.pdf"
    },
    {
      "do": "Let yourself go hungry between meals now and then instead of eating continuously",
      "image": "/images/practices/picard--pic-hungry-gap.webp?v=cea5a544",
      "chip": "Expert viewpoint",
      "expert": "Martin Picard",
      "url": "https://www.columbiadoctors.org/news/psychobiologist-explains-how-mitochondria-impact-your-health"
    },
    {
      "do": "Leave real rest days between burst sessions rather than bursting daily",
      "image": "/images/practices/pompa--pom-burst-rest.webp?v=6f4f505e",
      "chip": "Expert viewpoint",
      "expert": "Dr. Daniel Pompa",
      "url": "https://drpompa.com/health/burst-training-top-5-strategies-for-your-best-health-ever/"
    },
    {
      "do": "Never heat food or drink in plastic, and never microwave in a plastic container",
      "image": "/images/practices/rhonda-patrick--rhp-mp-noheat.webp?v=c5751e87",
      "chip": "Established",
      "expert": "Rhonda Patrick",
      "url": "https://www.foundmyfitness.com/episodes/microplastics"
    },
    {
      "do": "Move to a diet of whole plant foods close to their natural state",
      "image": "/images/practices/richroll--rol-eat-plants.webp?v=03f001c9",
      "chip": "Established",
      "expert": "Rich Roll",
      "url": "https://richroll.com/blog/10-reasons-to-consider-a-plant-based-diet/"
    },
    {
      "do": "Drink filtered water from glass containers rather than plastic bottles",
      "image": "/images/practices/saladino--sal-glass-not-plastic.webp?v=935ca289",
      "chip": "Emerging",
      "expert": "Paul Gregory Saladino",
      "url": "https://www.paulsaladinomd.com/psmd-newsletters/glass-bottles-more-microplastics-than-plastic"
    },
    {
      "do": "Contact one person you care about but have not spoken to in a while",
      "image": "/images/practices/santos--san-connect.webp?v=ac5cb761",
      "chip": "Emerging",
      "expert": "Laurie R. Santos",
      "url": "https://www.ted.com/podcasts/how-to-be-a-better-human/the-science-of-happiness-laurie-santos-transcript"
    },
    {
      "do": "Train each muscle at least twice a week",
      "image": "/images/practices/schoenfeld--sch-freq-2x.webp?v=be556cd6",
      "chip": "Contested",
      "expert": "Brad Schoenfeld",
      "url": "https://www.lookgreatnaked.com/blog/how-many-times-should-you-train-a-muscle-each-week/"
    },
    {
      "do": "Drink two to three cups of ground coffee a day if you drink coffee at all",
      "image": "/images/practices/schwarcz--sch-coffee.webp?v=c41f0491",
      "chip": "Established",
      "expert": "Joe Schwarcz",
      "url": "https://www.mcgill.ca/oss/article/health-and-nutrition/why-dr-joe-likes-his-cup-joe"
    },
    {
      "do": "Judge a hard session by how it fits the year, not by how wrecked it leaves you",
      "image": "/images/practices/seiler--sei-optimization-not-max.webp?v=122e693b",
      "chip": "Expert viewpoint",
      "expert": "Stephen Seiler",
      "url": "https://www.ebi.ac.uk/europepmc/webservices/rest/search?query=DOI:%2210.1139/apnm-2024-0012%22&format=json&resultType=core&pageSize=1"
    },
    {
      "do": "Do one interval session and two to three zone 2 sessions a week",
      "image": "/images/practices/siimland--sil-cardio.webp?v=a35d159a",
      "chip": "Established",
      "expert": "Siim Land",
      "url": "https://www.siimland.co/my-longevity-routine"
    },
    {
      "do": "Take 3 to 5 g of creatine monohydrate daily",
      "image": "/images/practices/sims--sim-creatine-dose.webp?v=0acba25d",
      "chip": "Established",
      "expert": "Stacy T. Sims",
      "url": "https://pubmed.ncbi.nlm.nih.gov/37221858/"
    },
    {
      "do": "Cut back on alcohol, or drop it",
      "image": "/images/practices/sinclair--sin-alcohol.webp?v=d3fd504a",
      "chip": "Contested",
      "expert": "David A. Sinclair",
      "url": "https://www.lifespanpodcast.com/the-science-of-looking-younger-longer/"
    },
    {
      "do": "Make new range usable: go slower through it, or stop and hold at the end of it",
      "image": "/images/practices/starrett--str-isometric-endrange.webp?v=a9ec5d48",
      "chip": "Expert viewpoint",
      "expert": "Kelly Starrett",
      "url": "https://tim.blog/2023/04/01/kelly-starrett-transcript/"
    },
    {
      "do": "Treat two standard drinks a week as the level Canada calls low risk",
      "image": "/images/practices/stockwell--sto-twoweek.webp?v=cd3b96ed",
      "chip": "Contested",
      "expert": "Tim Stockwell",
      "url": "https://www.ccsa.ca/en/guidance-tools-resources/substance-use-and-addiction/alcohol/canadas-guidance-alcohol-and-health"
    },
    {
      "do": "Skip food and drink that comes in a can",
      "image": "/images/practices/swan--swa-cans.webp?v=bd4aa74a",
      "chip": "Emerging",
      "expert": "Shanna H. Swan",
      "url": "https://www.hubermanlab.com/episode/dr-shanna-swan-how-to-safeguard-your-hormone-health-fertility"
    },
    {
      "do": "Cook with butter, lard, tallow or ghee instead of industrial seed oils",
      "image": "/images/practices/teicholz--tei-natural-fats.webp?v=db59ec0a",
      "chip": "Contested",
      "expert": "Nina Teicholz",
      "url": "https://ninateicholz.com/faqs/improving-diet-nutrition/"
    },
    {
      "do": "If you suspect you sleep badly, track it and work on the deep-sleep component",
      "image": "/images/practices/topol--top-sleep-track.webp?v=c3cbc0e9",
      "chip": "Expert viewpoint",
      "expert": "Eric Topol",
      "url": "https://insights.som.yale.edu/podcasts/health-veritas/eric-topol-the-keys-to-healthy-aging"
    },
    {
      "do": "Check the recycling code and skip plastics marked 3, 6 or 7 for food",
      "image": "/images/practices/trasande--tra-codes.webp?v=93dd54e8",
      "chip": "Established",
      "expert": "Leonardo Trasande",
      "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6309890/"
    },
    {
      "do": "Join a recurring activity where contact can grow through repetition",
      "image": "/images/practices/waldinger--wal-group.webp?v=2cf01919",
      "chip": "Expert viewpoint",
      "expert": "Robert Waldinger",
      "url": "https://news.harvard.edu/gazette/story/2023/02/work-out-daily-ok-but-how-socially-fit-are-you/"
    },
    {
      "do": "Move alcohol earlier in the evening, or off the evening",
      "image": "/images/practices/walker--wal-alcohol-evening.webp?v=46b424a1",
      "chip": "Established",
      "expert": "Matthew Walker",
      "url": "https://themattwalkerpodcast.buzzsprout.com/1821163/episodes/9591576-09-sleep-alcohol-part-2"
    },
    {
      "do": "Use routine hand hygiene at key moments to reduce infection transmission",
      "image": "/images/practices/who-healthy-living--who-hygiene.webp?v=9d7e4ad8",
      "chip": "Established",
      "expert": "WHO Healthy Living Guidance",
      "url": "https://www.who.int/europe/news-room/fact-sheets/item/everyday-actions-for-better-health-who-recommendations"
    },
    {
      "do": "Start exfoliating once a week and only increase if your skin handles it",
      "image": "/images/practices/wong--won-exfol-ramp.webp?v=ad6a9563",
      "chip": "Expert viewpoint",
      "expert": "Michelle Wong",
      "url": "https://labmuffin.com/how-to-exfoliate-3-choosing-the-right-exfoliants/"
    },
    {
      "do": "If you are drinking to fall asleep, stop",
      "image": "/images/practices/wu--wu-alcohol-not-a-sleep-aid.webp?v=d187c03e",
      "chip": "Established",
      "expert": "Jade Wu",
      "url": "https://www.drjadewu.com/resources"
    },
    {
      "do": "Ask where the fat came from rather than whether fat is good or bad",
      "image": "/images/practices/yeo--yeo-unsat-over-sat.webp?v=97705147",
      "chip": "Established",
      "expert": "Giles Yeo",
      "url": "https://www.sciencefocus.com/the-human-body/weight-loss-myths"
    },
    {
      "do": "Pace demanding activity so you stop swinging between doing too much and crashing",
      "image": "/images/practices/zoffness--zof-pace.webp?v=80f3e5f6",
      "chip": "Established",
      "expert": "Rachel Zoffness",
      "url": "https://www.zoffness.com/resources"
    }
  ],
  "questions": [
    {
      "id": "after-55-is-more-protein-protective-sxdn",
      "question": "After 55, is more protein protective or risky?",
      "image": "/images/crossfire/after-55-is-more-protein-protective-sxdn.webp?v=a35a39d1",
      "people": [
        {
          "name": "Joel Kahn",
          "url": "https://www.kahnlongevitycenter.com/blog/do-high-protein-diets-increase-the-risk-of-heart-events-and-death"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/protein-deep-dive-episode-29/"
        }
      ]
    },
    {
      "id": "are-cold-showers-and-saunas-worth-1wtp",
      "question": "Are cold showers and saunas worth doing for your nervous system?",
      "image": "/images/crossfire/are-cold-showers-and-saunas-worth-1wtp.webp?v=c83f62c8",
      "people": [
        {
          "name": "Dan Harris",
          "url": "https://danharris.substack.com/p/the-calm-switch-in-your-bodyand-how"
        },
        {
          "name": "Andrea Love",
          "url": null
        }
      ]
    },
    {
      "id": "are-seed-oils-something-you-should-1hne",
      "question": "Are seed oils something you should worry about?",
      "image": "/images/crossfire/are-seed-oils-something-you-should-1hne.webp?v=3c80778c",
      "people": [
        {
          "name": "Lara Adler",
          "url": "https://talkingtoxins.substack.com/p/the-messenger-can-kill-the-message"
        },
        {
          "name": "Ken D. Berry",
          "url": "https://drberry.com/pages/proper-human-diet,"
        }
      ]
    },
    {
      "id": "are-stem-cell-treatments-getting-cheaper-gyce",
      "question": "Are stem cell treatments getting cheaper as more clinics open?",
      "image": "/images/crossfire/are-stem-cell-treatments-getting-cheaper-gyce.webp?v=2d6e2403",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/what-are-stem-cells-types-27-03-19/"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://ipscell.com/2025/10/stem-cell-therapy-cost-goes-up-what-to-consider-looking-ahead/"
        }
      ]
    },
    {
      "id": "are-the-plastic-chemicals-in-everyday-13xn",
      "question": "Are the plastic chemicals in everyday products actually harming me at the doses I get?",
      "image": "/images/crossfire/are-the-plastic-chemicals-in-everyday-13xn.webp?v=19b843d9",
      "people": [
        {
          "name": "Leonardo Trasande",
          "url": "https://pubmed.ncbi.nlm.nih.gov/25742516/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/macropanic-over-nanoplastics"
        }
      ]
    },
    {
      "id": "can-a-ranking-of-the-best-1n0c",
      "question": "Can a ranking of the best diets tell me which one is healthiest?",
      "image": "/images/crossfire/can-a-ranking-of-the-best-1n0c.webp?v=ce05293f",
      "people": [
        {
          "name": "Nina Teicholz",
          "url": "https://unsettledscience.substack.com/p/is-keto-bad-for-the-heart"
        },
        {
          "name": "Christopher D. Gardner",
          "url": "https://profiles.stanford.edu/christopher-gardner"
        }
      ]
    },
    {
      "id": "can-i-put-my-type-2-kt0j",
      "question": "Can I put my type 2 diabetes into remission with food, and which food?",
      "image": "/images/crossfire/can-i-put-my-type-2-kt0j.webp?v=7c2a62ff",
      "people": [
        {
          "name": "Neal Barnard",
          "url": "https://pubmed.ncbi.nlm.nih.gov/16873779/"
        },
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/how-to-reverse-type-2-diabetes-the-quick-start-guide/"
        }
      ]
    },
    {
      "id": "can-you-change-your-chronotype-or-3zje",
      "question": "Can you change your chronotype, or do you have to live with it?",
      "image": "/images/crossfire/can-you-change-your-chronotype-or-3zje.webp?v=3a34e646",
      "people": [
        {
          "name": "Michael J. Breus",
          "url": "https://sleepdoctor.com/pages/chronotypes/chronotypes,"
        },
        {
          "name": "Jade Wu",
          "url": "https://www.drjadewu.com/resources,"
        }
      ]
    },
    {
      "id": "can-you-get-enough-protein-from-oov7",
      "question": "Can you get enough protein from plants alone?",
      "image": "/images/crossfire/can-you-get-enough-protein-from-oov7.webp?v=3a20b066",
      "people": [
        {
          "name": "Kristina Carrillo-Bucaram",
          "url": "https://www.fullyraw.com/blog/3-easy-ways-to-get-protein-on-a-raw-vegan-diet"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/articles/nutrition/protein-requirements-amount-timing-type/"
        }
      ]
    },
    {
      "id": "did-ornish-s-trials-show-that-1bem",
      "question": "Did Ornish's trials show that a plant-based diet reverses heart disease?",
      "image": "/images/crossfire/did-ornish-s-trials-show-that-1bem.webp?v=7f7c90c8",
      "people": [
        {
          "name": "Dean Michael Ornish",
          "url": "https://pubmed.ncbi.nlm.nih.gov/1973470/"
        },
        {
          "name": "Nina Teicholz",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11944661/"
        }
      ]
    },
    {
      "id": "did-the-twin-study-show-that-1geu",
      "question": "Did the twin study show that going vegan is better, or just that eating less is?",
      "image": "/images/crossfire/did-the-twin-study-show-that-1geu.webp?v=c1ebd128",
      "people": [
        {
          "name": "Christopher D. Gardner",
          "url": "https://jamanetwork.com/journals/jamanetworkopen/fullarticle/2812392"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/vegan-v-omnivore-diet-study/"
        }
      ]
    },
    {
      "id": "do-adaptogens-like-ashwagandha-actually-balance-gcc5",
      "question": "Do adaptogens like ashwagandha actually balance your stress hormones?",
      "image": "/images/crossfire/do-adaptogens-like-ashwagandha-actually-balance-gcc5.webp?v=b1bc544c",
      "people": [
        {
          "name": "Aviva Romm",
          "url": "https://avivaromm.com/adaptogens-beating-stress/"
        },
        {
          "name": "Jennifer Gunter",
          "url": "https://vajenda.substack.com/p/congrats-ladies-midis-cure-for-structural"
        }
      ]
    },
    {
      "id": "does-a-healthy-adult-need-to-adht",
      "question": "Does a healthy adult need to eat carbohydrate?",
      "image": "/images/crossfire/does-a-healthy-adult-need-to-adht.webp?v=4b5ddf7a",
      "people": [
        {
          "name": "Paul Gregory Saladino",
          "url": "https://podcasts.apple.com/us/podcast/172-dangers-of-a-keto-diet/id1461771083?i=1000570399175"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/a-beginners-introduction-to-the-carnivore-diet/"
        }
      ]
    },
    {
      "id": "does-a-plant-based-diet-need-1qp0",
      "question": "Does a plant-based diet need to be very low in fat, or do nuts, seeds and avocados belong in it?",
      "image": "/images/crossfire/does-a-plant-based-diet-need-1qp0.webp?v=953b9c8b",
      "people": [
        {
          "name": "Brenda Davis",
          "url": "https://brendadavisrd.com/faq/"
        },
        {
          "name": "Dean Michael Ornish",
          "url": "https://pubmed.ncbi.nlm.nih.gov/9863851/"
        }
      ]
    },
    {
      "id": "does-eating-less-often-lower-insulin-1v5u",
      "question": "Does eating less often lower insulin in a way that makes you lose weight?",
      "image": "/images/crossfire/does-eating-less-often-lower-insulin-1v5u.webp?v=64b54674",
      "people": [
        {
          "name": "Yvette d'Entremont",
          "url": "http://web.archive.org/web/20220502213138id_/https://scibabe.com/daily-mos-intermittent-fasting"
        },
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/power-fasting-vs-low-carb-fasting-26/"
        }
      ]
    },
    {
      "id": "does-fruit-belong-in-an-animal-1rd9",
      "question": "Does fruit belong in an animal-based diet?",
      "image": "/images/crossfire/does-fruit-belong-in-an-animal-1rd9.webp?v=f34c37ca",
      "people": [
        {
          "name": "Anthony Chaffee",
          "url": "https://dranthonychaffee.com/blog/can-you-eat-fruit-on-a-carnivore-diet"
        },
        {
          "name": "Paul Gregory Saladino",
          "url": "https://www.paulsaladinomd.com/animal-based-diet"
        }
      ]
    },
    {
      "id": "does-how-you-structure-your-training-l8nk",
      "question": "Does how you structure your training programme matter, or just how much you do?",
      "image": "/images/crossfire/does-how-you-structure-your-training-l8nk.webp?v=1e73ffa7",
      "people": [
        {
          "name": "Brad Schoenfeld",
          "url": "https://pubmed.ncbi.nlm.nih.gov/41843416/"
        },
        {
          "name": "Mike Israetel",
          "url": "https://rpstrength.com/blogs/articles/progressing-for-hypertrophy"
        }
      ]
    },
    {
      "id": "does-it-matter-how-you-spread-io8o",
      "question": "Does it matter how you spread your protein through the day?",
      "image": "/images/crossfire/does-it-matter-how-you-spread-io8o.webp?v=c1f9a186",
      "people": [
        {
          "name": "Alan Aragon",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC5828430/"
        },
        {
          "name": "Layne Norton",
          "url": null
        }
      ]
    },
    {
      "id": "does-it-matter-when-i-eat-v39r",
      "question": "Does it matter when I eat, or only how much?",
      "image": "/images/crossfire/does-it-matter-when-i-eat-v39r.webp?v=08c4de45",
      "people": [
        {
          "name": "Satchidananda Panda",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC6953486/"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/things-ive-changed-my-mind-on-episode-5/"
        }
      ]
    },
    {
      "id": "does-it-matter-whether-the-sugar-1xnt",
      "question": "Does it matter whether the sugar in a food is added or naturally there?",
      "image": "/images/crossfire/does-it-matter-whether-the-sugar-1xnt.webp?v=8ce9dda7",
      "people": [
        {
          "name": "Dr Idrees Hamid Mughal",
          "url": "https://www.foodfacts.org/articles/honey-spikes-blood-sugar"
        },
        {
          "name": "Jessie Inchauspé",
          "url": "https://www.glucosegoddess.com/pages/science-episode-how-to-read-food-labels"
        }
      ]
    },
    {
      "id": "does-meditation-actually-make-you-happier-6ls0",
      "question": "Does meditation actually make you happier, or just less anxious?",
      "image": "/images/crossfire/does-meditation-actually-make-you-happier-6ls0.webp?v=5e38df69",
      "people": [
        {
          "name": "Dan Harris",
          "url": "https://podscripts.co/podcasts/ten-percent-happier-with-dan-harris/eight-things-im-doing-to-stay-sane-during-election-season-dan-harris"
        },
        {
          "name": "Laurie R. Santos",
          "url": "https://pubmed.ncbi.nlm.nih.gov/37474838/"
        }
      ]
    },
    {
      "id": "does-my-body-need-help-detoxifying-6eqz",
      "question": "Does my body need help detoxifying?",
      "image": "/images/crossfire/does-my-body-need-help-detoxifying-6eqz.webp?v=4bb504de",
      "people": [
        {
          "name": "Dr. Daniel Pompa",
          "url": "https://drpompa.com/cellular-detox/pompacore-cellular-detox-a-top-5-strategy-to-create-your-best-health-ever/"
        },
        {
          "name": "Giles Yeo",
          "url": "https://www.sciencefocus.com/the-human-body/weight-loss-myths"
        }
      ]
    },
    {
      "id": "does-my-pediatrician-have-a-financial-45fh",
      "question": "Does my pediatrician have a financial reason to push vaccines?",
      "image": "/images/crossfire/does-my-pediatrician-have-a-financial-45fh.webp?v=6a80a7ed",
      "people": [
        {
          "name": "Jessica B. Steier",
          "url": "https://theunbiasedscipod.substack.com/p/do-pediatricians-make-large-profits"
        },
        {
          "name": "Dr. Daniel Pompa",
          "url": "https://drpompa.com/cellular-detox/detox-your-life-my-toxic-top-10/"
        }
      ]
    },
    {
      "id": "does-your-body-need-help-clearing-1ltk",
      "question": "Does your body need help clearing out hormones each month?",
      "image": "/images/crossfire/does-your-body-need-help-clearing-1ltk.webp?v=8f74f29f",
      "people": [
        {
          "name": "Mindy Hetzer Pelz",
          "url": "https://www.drmindypelz.com/how-long-to-fast-during-your-cycle"
        },
        {
          "name": "Jennifer Gunter",
          "url": "https://vajenda.substack.com/p/the-menstrual-cycle-is-not-a-detox"
        }
      ]
    },
    {
      "id": "do-everyday-blood-sugar-spikes-actually-fnz5",
      "question": "Do everyday blood sugar spikes actually age you?",
      "image": "/images/crossfire/do-everyday-blood-sugar-spikes-actually-fnz5.webp?v=bdb42562",
      "people": [
        {
          "name": "Jessie Inchauspé",
          "url": "https://www.glucosegoddess.com/pages/science-episode-why-glucose-matters"
        },
        {
          "name": "Nicola Guess",
          "url": "https://drguess.substack.com/p/the-glucose-goddess"
        }
      ]
    },
    {
      "id": "do-everyday-low-doses-of-hormone-dvgz",
      "question": "Do everyday low doses of hormone-mimicking chemicals matter, or does the dose still make the poison?",
      "image": "/images/crossfire/do-everyday-low-doses-of-hormone-dvgz.webp?v=830e7fde",
      "people": [
        {
          "name": "John Peterson Myers",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3365860/"
        },
        {
          "name": "Michelle Wong",
          "url": "https://labmuffin.com/sunscreen-myth-directory/"
        }
      ]
    },
    {
      "id": "do-i-actually-need-eight-hours-wg3z",
      "question": "Do I actually need eight hours of sleep?",
      "image": "/images/crossfire/do-i-actually-need-eight-hours-wg3z.webp?v=ccc0300f",
      "people": [
        {
          "name": "Daniel E. Lieberman",
          "url": "https://www.mountsinai.org/about/newsroom/podcasts/road-resilience/archive/weirdos-guide"
        },
        {
          "name": "Matthew Walker",
          "url": "https://sleepdiplomat.wordpress.com/2019/12/19/why-we-sleep-responses-to-questions-from-readers/"
        }
      ]
    },
    {
      "id": "do-i-have-to-give-up-1j5h",
      "question": "Do I have to give up animal foods completely?",
      "image": "/images/crossfire/do-i-have-to-give-up-1j5h.webp?v=43ee2278",
      "people": [
        {
          "name": "Simon Hill",
          "url": "https://theproof.com/wp-content/uploads/2023/06/TP_LipidCheatSheet.pdf"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/video/how-plant-based-to-lower-igf-1/"
        }
      ]
    },
    {
      "id": "do-i-have-to-go-all-13im",
      "question": "Do I have to go all the way to vegan, or is adding more plants enough?",
      "image": "/images/crossfire/do-i-have-to-go-all-13im.webp?v=001dd1be",
      "people": [
        {
          "name": "Christopher D. Gardner",
          "url": "https://med.stanford.edu/news/all-news/2023/11/twin-diet-vegan-cardiovascular.html"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/video/how-plant-based-to-lower-igf-1/"
        }
      ]
    },
    {
      "id": "do-i-need-a-detox-or-o0ju",
      "question": "Do I need a detox or cleanse protocol?",
      "image": "/images/crossfire/do-i-need-a-detox-or-o0ju.webp?v=a1cb39f2",
      "people": [
        {
          "name": "Timothy Caulfield",
          "url": "https://lifeasahuman.com/2015/health-fitness/health/the-detox-myth-how-celebrity-culture-sells-us-what-we-dont-need/"
        },
        {
          "name": "Dr. Daniel Pompa",
          "url": "https://drpompa.com/cellular-detox/pompacore-cellular-detox-a-top-5-strategy-to-create-your-best-health-ever/"
        }
      ]
    },
    {
      "id": "do-i-need-to-eat-plants-1aht",
      "question": "Do I need to eat plants at all?",
      "image": "/images/crossfire/do-i-need-to-eat-plants-1aht.webp?v=1b934f14",
      "people": [
        {
          "name": "Kristina Carrillo-Bucaram",
          "url": "https://magazine.rice.edu/summer-2017/bandvegan"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/"
        }
      ]
    },
    {
      "id": "do-i-need-to-get-rid-1o31",
      "question": "Do I need to get rid of my non-stick pans?",
      "image": "/images/crossfire/do-i-need-to-get-rid-1o31.webp?v=96c532e2",
      "people": [
        {
          "name": "Yvonne Burkart",
          "url": "https://dryvonneburkart.com/are-non-stick-pans-safe-the-hidden-risks-of-pfas-smarter-cookware-swaps/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/health-and-nutrition/concerns-about-cookware-chemistry"
        }
      ]
    },
    {
      "id": "do-whole-grains-belong-in-a-1yki",
      "question": "Do whole grains belong in a healthy diet, or should you cut them out?",
      "image": "/images/crossfire/do-whole-grains-belong-in-a-1yki.webp?v=2c381d37",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/fibermaxxing-the-fiber-advice-making-you-inflamed-and-what-to-do-instead/"
        },
        {
          "name": "Ken D. Berry",
          "url": "https://drberry.com/pages/proper-human-diet"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/daily-dozen/"
        }
      ]
    },
    {
      "id": "do-you-have-to-eat-a-ce6r",
      "question": "Do you have to eat a high-carbohydrate diet to perform in endurance sport?",
      "image": "/images/crossfire/do-you-have-to-eat-a-ce6r.webp?v=bb321476",
      "people": [
        {
          "name": "Louise Mary Burke",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC13197943/"
        },
        {
          "name": "Timothy David Noakes",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC13197914/"
        }
      ]
    },
    {
      "id": "for-early-alzheimer-s-disease-should-gcni",
      "question": "For early Alzheimer's disease, should the diet go high fat or very low fat?",
      "image": "/images/crossfire/for-early-alzheimer-s-disease-should-gcni.webp?v=3d0dd8a7",
      "people": [
        {
          "name": "Christopher M. Palmer",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9870323/"
        },
        {
          "name": "Dean Michael Ornish",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11157928/"
        }
      ]
    },
    {
      "id": "for-losing-weight-does-it-matter-wyyq",
      "question": "For losing weight, does it matter whether I cut fat or cut carbs?",
      "image": "/images/crossfire/for-losing-weight-does-it-matter-wyyq.webp?v=430cd147",
      "people": [
        {
          "name": "Nina Teicholz",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11944661/"
        },
        {
          "name": "Christopher D. Gardner",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2673150"
        }
      ]
    },
    {
      "id": "for-type-2-diabetes-does-a-1y9e",
      "question": "For type 2 diabetes, does a ketogenic diet actually beat a Mediterranean one on blood sugar?",
      "image": "/images/crossfire/for-type-2-diabetes-does-a-1y9e.webp?v=073dc95d",
      "people": [
        {
          "name": "Eric Charles Westman",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9535512/"
        },
        {
          "name": "Christopher D. Gardner",
          "url": "https://pubmed.ncbi.nlm.nih.gov/35641199/"
        }
      ]
    },
    {
      "id": "how-do-you-know-you-are-1cui",
      "question": "How do you know you are in Zone 2, and does the number matter?",
      "image": "/images/crossfire/how-do-you-know-you-are-1cui.webp?v=9cd3d309",
      "people": [
        {
          "name": "Iñigo San Millán",
          "url": "https://inigosanmillan.substack.com/p/zone-2-is-a-metabolic-equilibrium"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/inigosanmillan2/"
        }
      ]
    },
    {
      "id": "how-far-should-i-go-to-1ot2",
      "question": "How far should I go to get plastic out of my house?",
      "image": "/images/crossfire/how-far-should-i-go-to-1ot2.webp?v=0985744e",
      "people": [
        {
          "name": "Shanna H. Swan",
          "url": "https://pubmed.ncbi.nlm.nih.gov/41893525/"
        },
        {
          "name": "Leonardo Trasande",
          "url": "https://nyulangone.org/news/seven-tips-reducing-your-exposure-microplastics-plastic-additives"
        },
        {
          "name": "Beatrice Gomberg",
          "url": "https://taborplace.co/blogs/plastic-is-toxic/are-microplastics-the-lead-of-our-generation-10-ways-to-avoid-microplastics"
        }
      ]
    },
    {
      "id": "how-far-should-i-go-to-1x7g",
      "question": "How far should I go to get chemicals out of my house?",
      "image": "/images/crossfire/how-far-should-i-go-to-1x7g.webp?v=57fecb42",
      "people": [
        {
          "name": "Beatrice Gomberg",
          "url": "https://taborplace.co/blogs/plastic-is-toxic/are-microplastics-the-lead-of-our-generation-10-ways-to-avoid-microplastics"
        },
        {
          "name": "Aly Cohen",
          "url": "https://www.mindbodygreen.com/articles/doctors-stress-free-guide-to-reducing-chemical-exposure"
        },
        {
          "name": "Leonardo Trasande",
          "url": "https://nyulangone.org/news/seven-tips-reducing-your-exposure-microplastics-plastic-additives"
        }
      ]
    },
    {
      "id": "how-long-should-a-fast-be-1m5h",
      "question": "How long should a fast be?",
      "image": "/images/crossfire/how-long-should-a-fast-be-1m5h.webp?v=d5807de0",
      "people": [
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/longer-fasting-regimens-part-7/"
        },
        {
          "name": "Satchidananda Panda",
          "url": "https://www.hubermanlab.com/episode/dr-satchin-panda-intermittent-fasting-to-improve-health-cognition-and-longevity"
        },
        {
          "name": "Valter Longo",
          "url": "https://www.fondazionevalterlongo.org/wp-content/uploads/2024/02/2024-01_fondazione-longo_digiuno-e-longevita-EN-libro.pdf"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/things-ive-changed-my-mind-on-episode-5/"
        }
      ]
    },
    {
      "id": "how-much-protein-do-i-actually-mwoj",
      "question": "How much protein do I actually need?",
      "image": "/images/crossfire/how-much-protein-do-i-actually-mwoj.webp?v=7fc6f359",
      "people": [
        {
          "name": "Christopher D. Gardner",
          "url": "https://med.stanford.edu/news/all-news/2019/02/5-questions-gardner-on-meat-protein-and-environment.html"
        },
        {
          "name": "Gabrielle Lyon",
          "url": "https://drgabriellelyon.com/wp-content/uploads/2024/01/The-Lyon-Protocol-Dr.-Gabrielle-Lyon.pdf"
        },
        {
          "name": "Simon Hill",
          "url": "https://theproof.com/protein-versus-resistance-training/"
        },
        {
          "name": "Jessie Inchauspé",
          "url": "https://www.glucosegoddess.com/pages/science-episode-protein"
        },
        {
          "name": "Rich Roll",
          "url": "https://richroll.com/faq/"
        },
        {
          "name": "Eric Topol",
          "url": "https://erictopol.substack.com/p/our-preoccupation-with-protein-intake"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/determining-optimal-protein-intake/"
        }
      ]
    },
    {
      "id": "how-much-protein-do-you-actually-1wm7",
      "question": "How much protein do you actually need, and does it matter whether it comes from plants or animals?",
      "image": "/images/crossfire/how-much-protein-do-you-actually-1wm7.webp?v=bea78124",
      "people": [
        {
          "name": "Joel H. Fuhrman",
          "url": "https://www.drfuhrman.com/articles/64/how-plant-protein-wins-over-animal-protein,"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/determining-optimal-protein-intake/,"
        }
      ]
    },
    {
      "id": "how-much-protein-should-a-healthy-rwvh",
      "question": "How much protein should a healthy adult under 65 eat?",
      "image": "/images/crossfire/how-much-protein-should-a-healthy-rwvh.webp?v=bbdbde84",
      "people": [
        {
          "name": "Siim Land",
          "url": "https://www.siimland.co/my-longevity-routine,"
        },
        {
          "name": "Valter Longo",
          "url": "https://valterlongo.com/daily-longevity-diet-for-adults/,"
        }
      ]
    },
    {
      "id": "how-much-protein-should-i-actually-vioa",
      "question": "How much protein should I actually eat?",
      "image": "/images/crossfire/how-much-protein-should-i-actually-vioa.webp?v=14b410eb",
      "people": [
        {
          "name": "T. Colin Campbell",
          "url": "https://nutritionstudies.org/the-upper-safe-limit-for-protein-consumption-excerpt/"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/keys-to-building-muscle-part-2-nutrition-episode-18/"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/video/does-increasing-protein-intake-slow-age-related-muscle-mass-loss/"
        },
        {
          "name": "Gabrielle Lyon",
          "url": "https://drgabriellelyon.com/"
        },
        {
          "name": "Valter Longo",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3988204/"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/peter-faq/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/health-and-nutrition/muscle-building-not-routine-its-triggered-protein"
        }
      ]
    },
    {
      "id": "how-much-protein-should-i-eat-eo8d",
      "question": "How much protein should I eat?",
      "image": "/images/crossfire/how-much-protein-should-i-eat-eo8d.webp?v=2e84717d",
      "people": [
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/how-much-protein-is-excessive/"
        },
        {
          "name": "Gabrielle Lyon",
          "url": "https://drgabriellelyon.com/wp-content/uploads/2024/01/The-Lyon-Protocol-Dr.-Gabrielle-Lyon.pdf"
        },
        {
          "name": "Valter Longo",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC3988204/"
        },
        {
          "name": "Dr. Daniel Pompa",
          "url": "https://drpompa.com/cellular-detox/anti-aging-lifestyle-commandments/,"
        },
        {
          "name": "Layne Norton",
          "url": null
        }
      ]
    },
    {
      "id": "how-much-salt-should-you-eat-1tr7",
      "question": "How much salt should you eat?",
      "image": "/images/crossfire/how-much-salt-should-you-eat-1tr7.webp?v=68f8ac68",
      "people": [
        {
          "name": "Judy Cho",
          "url": "https://www.nutritionwithjudy.com/sole-water-recipe-balancing-electrolytes/"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/video/salt-of-the-earth-sodium-and-plant-based-diets/"
        },
        {
          "name": "Dariush Mozaffarian",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4814348/"
        },
        {
          "name": "Stephen D. Phinney",
          "url": "https://www.virtahealth.com/blog/sodium-nutritional-ketosis-keto-flu-adrenal-function"
        }
      ]
    },
    {
      "id": "how-much-testing-and-intervention-does-1new",
      "question": "How much testing and intervention does a longevity routine actually need?",
      "image": "/images/crossfire/how-much-testing-and-intervention-does-1new.webp?v=1a4557fd",
      "people": [
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/peter-faq/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/medical-critical-thinking-health-and-nutrition/there-are-lots-longevity-regimens-one-stands-out-me"
        },
        {
          "name": "Martin Picard",
          "url": "https://tseenergy.substack.com/p/you-are-not-the-average"
        }
      ]
    },
    {
      "id": "if-cutting-carbs-works-for-me-wh0h",
      "question": "If cutting carbs works for me, what is it that's actually working?",
      "image": "/images/crossfire/if-cutting-carbs-works-for-me-wh0h.webp?v=a5705b15",
      "people": [
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/a-beginners-introduction-to-the-carnivore-diet/"
        },
        {
          "name": "Giles Yeo",
          "url": "https://www.sciencefocus.com/the-human-body/dieting-rules"
        }
      ]
    },
    {
      "id": "if-i-cut-carbs-and-eat-1vhr",
      "question": "If I cut carbs and eat when I'm hungry, will the fat come off on its own?",
      "image": "/images/crossfire/if-i-cut-carbs-and-eat-1vhr.webp?v=454de73d",
      "people": [
        {
          "name": "Benjamin T. Bikman",
          "url": "https://magazine.byu.edu/article/the-diet-of-champions/"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/33479499/"
        }
      ]
    },
    {
      "id": "if-i-don-t-have-diabetes-zey8",
      "question": "If I don't have diabetes, is it worth trying to flatten my blood sugar spikes?",
      "image": "/images/crossfire/if-i-don-t-have-diabetes-zey8.webp?v=2dc3f9bb",
      "people": [
        {
          "name": "Jessie Inchauspé",
          "url": "https://www.glucosegoddess.com/pages/science-episode-why-glucose-matters"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/39755436/"
        }
      ]
    },
    {
      "id": "if-i-eat-more-butter-and-j5pj",
      "question": "If I eat more butter and cheese, is that bad for my heart?",
      "image": "/images/crossfire/if-i-eat-more-butter-and-j5pj.webp?v=35cbced8",
      "people": [
        {
          "name": "Nina Teicholz",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9794145/"
        },
        {
          "name": "Gil Carvalho",
          "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified"
        }
      ]
    },
    {
      "id": "if-i-eat-this-way-and-1u7s",
      "question": "If I eat this way and my cholesterol goes up, does it matter?",
      "image": "/images/crossfire/if-i-eat-this-way-and-1u7s.webp?v=f0184bd9",
      "people": [
        {
          "name": "Gil Carvalho",
          "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified,"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/carnivore-diet-side-effects/,"
        }
      ]
    },
    {
      "id": "if-i-have-insomnia-can-i-pqlt",
      "question": "If I have insomnia, can I nap?",
      "image": "/images/crossfire/if-i-have-insomnia-can-i-pqlt.webp?v=205682a2",
      "people": [
        {
          "name": "Shelby Harris",
          "url": "https://drshelbyharris.com/sleep-problems-adults/"
        },
        {
          "name": "Jade Wu",
          "url": "https://www.drjadewu.com/resources"
        }
      ]
    },
    {
      "id": "if-i-only-have-a-few-r21y",
      "question": "If I only have a few hours a week, should I train mostly easy and long, or mostly short and hard?",
      "image": "/images/crossfire/if-i-only-have-a-few-r21y.webp?v=fb47dd5e",
      "people": [
        {
          "name": "Stephen Seiler",
          "url": "https://journals.humankinetics.com/view/journals/ijspp/5/3/article-p276.xml"
        },
        {
          "name": "Martin J. Gibala",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4846072/"
        }
      ]
    },
    {
      "id": "if-i-used-to-smoke-should-6qg0",
      "question": "If I used to smoke, should I get the yearly CT scan for lung cancer?",
      "image": "/images/crossfire/if-i-used-to-smoke-should-6qg0.webp?v=95bb6fde",
      "people": [
        {
          "name": "Vinay Prasad",
          "url": "https://www.drvinayprasad.com/p/clarifying-a-few-misconceptions-about"
        },
        {
          "name": "American Cancer Society Prevention and Screening",
          "url": "https://www.cancer.org/cancer/types/lung-cancer/detection-diagnosis-staging/screening.html"
        }
      ]
    },
    {
      "id": "if-my-brain-were-preserved-would-wxr0",
      "question": "If my brain were preserved, would there still be a person in there to bring back?",
      "image": "/images/crossfire/if-my-brain-were-preserved-would-wxr0.webp?v=1bc37535",
      "people": [
        {
          "name": "Max More",
          "url": "https://biostasis.substack.com/p/does-the-brain-die-after-a-few-minutes"
        },
        {
          "name": "Venki Ramakrishnan",
          "url": "https://www.livescience.com/health/death/we-dont-yet-have-the-know-how-to-properly-maintain-a-corpse-brain-why-cryonics-is-a-non-starter-in-our-quest-for-immortality"
        }
      ]
    },
    {
      "id": "if-my-gut-is-a-mess-yihw",
      "question": "If my gut is a mess, should I eat more fiber or none at all?",
      "image": "/images/crossfire/if-my-gut-is-a-mess-yihw.webp?v=d09d0323",
      "people": [
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/a-beginners-introduction-to-the-carnivore-diet/"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/hnta-video/constipation-is-a-fiber-deficiency-disease/"
        },
        {
          "name": "Gil Carvalho",
          "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified,"
        }
      ]
    },
    {
      "id": "if-saturated-fat-isn-t-the-1jpl",
      "question": "If saturated fat isn't the problem, does that mean animal foods are fine?",
      "image": "/images/crossfire/if-saturated-fat-isn-t-the-1jpl.webp?v=53dc732c",
      "people": [
        {
          "name": "T. Colin Campbell",
          "url": "https://nutritionstudies.org/is-saturated-fat-really-that-bad/"
        },
        {
          "name": "Nina Teicholz",
          "url": "https://ninateicholz.com/faqs/improving-diet-nutrition/"
        }
      ]
    },
    {
      "id": "if-you-are-a-woman-over-1lnh",
      "question": "If you are a woman over 40, how long should you fast?",
      "image": "/images/crossfire/if-you-are-a-woman-over-1lnh.webp?v=594121c0",
      "people": [
        {
          "name": "Sara Szal Gottfried",
          "url": "https://saraszalmd.substack.com/p/fasting-at-40-and-beyond-how-to-get,"
        },
        {
          "name": "Mindy Hetzer Pelz",
          "url": "https://www.drmindypelz.com/how-long-to-fast-during-your-cycle,"
        }
      ]
    },
    {
      "id": "if-you-do-not-have-diabetes-1dqs",
      "question": "If you do not have diabetes, is it worth managing your glucose spikes?",
      "image": "/images/crossfire/if-you-do-not-have-diabetes-1dqs.webp?v=d3aaaacd",
      "people": [
        {
          "name": "Nicola Guess",
          "url": "https://drguess.substack.com/p/the-glucose-goddess"
        },
        {
          "name": "Jessie Inchauspé",
          "url": "https://www.glucosegoddess.com/pages/science-episode-why-glucose-matters"
        }
      ]
    },
    {
      "id": "if-you-eat-zero-carbohydrate-do-lwxw",
      "question": "If you eat zero carbohydrate, do you still need vitamin C, and does everyone need to go that far?",
      "image": "/images/crossfire/if-you-eat-zero-carbohydrate-do-lwxw.webp?v=3c9b1c31",
      "people": [
        {
          "name": "Anthony Chaffee",
          "url": "https://adaptyourlifeacademy.com/science/dr-anthony-chaffee-and-dr-westman-discuss-the-carnivore-diet/"
        },
        {
          "name": "Eric Charles Westman",
          "url": "https://adaptyourlifeacademy.com/low-carb/what-is-your-carb-threshold/"
        }
      ]
    },
    {
      "id": "if-you-have-an-autoimmune-disease-w4bs",
      "question": "If you have an autoimmune disease, should you cut out all animal foods or all plant foods?",
      "image": "/images/crossfire/if-you-have-an-autoimmune-disease-w4bs.webp?v=71fcf2ab",
      "people": [
        {
          "name": "Brooke Goldner",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10949923/"
        },
        {
          "name": "Anthony Chaffee",
          "url": "https://dranthonychaffee.com/blog/dr-chaffees-protocol-for-optimizing-multiple-sclerosis-recovery"
        }
      ]
    },
    {
      "id": "if-you-take-exogenous-ketones-every-1fjp",
      "question": "If you take exogenous ketones every day, does the formulation matter, and which one?",
      "image": "/images/crossfire/if-you-take-exogenous-ketones-every-1fjp.webp?v=08a03c6d",
      "people": [
        {
          "name": "Dominic P. D'Agostino",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12566606/"
        },
        {
          "name": "Benjamin T. Bikman",
          "url": "https://shows.acast.com/the-metabolic-classroom/episodes/exogenous-ketones-with-dr-ben-bikman"
        }
      ]
    },
    {
      "id": "if-you-want-to-lose-weight-1f68",
      "question": "If you want to lose weight, does it matter how many calories you eat, or only what you eat?",
      "image": "/images/crossfire/if-you-want-to-lose-weight-1f68.webp?v=b460377b",
      "people": [
        {
          "name": "Rangan Chatterjee",
          "url": "https://drchatterjee.com/blog/11-ways-to-reverse-diabetes/"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/what-really-matters-for-fat-loss-episode-6/"
        }
      ]
    },
    {
      "id": "if-you-want-to-lose-weight-1sdl",
      "question": "If you want to lose weight, is a very low-fat plant-based diet the one to pick?",
      "image": "/images/crossfire/if-you-want-to-lose-weight-1sdl.webp?v=c6027a3d",
      "people": [
        {
          "name": "Dean Michael Ornish",
          "url": "https://www.scientificamerican.com/article/why-almost-everything-dean-ornish-says-about-nutrition-is-wrong/"
        },
        {
          "name": "Christopher D. Gardner",
          "url": "https://pubmed.ncbi.nlm.nih.gov/17341711/"
        }
      ]
    },
    {
      "id": "is-a-daily-glass-or-two-1hrd",
      "question": "Is a daily glass or two of wine good for you?",
      "image": "/images/crossfire/is-a-daily-glass-or-two-1hrd.webp?v=71c56eb7",
      "people": [
        {
          "name": "Dan Buettner",
          "url": "https://www.bluezones.com/2016/11/power-9/"
        },
        {
          "name": "Tim Stockwell",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10066463/"
        }
      ]
    },
    {
      "id": "is-a-detox-programme-a-useful-1dzw",
      "question": "Is a detox programme a useful thing to do, or a sign that you should walk away?",
      "image": "/images/crossfire/is-a-detox-programme-a-useful-1dzw.webp?v=d80c5a8b",
      "people": [
        {
          "name": "Mark Hyman",
          "url": "https://drhyman.com/pages/10-day-detox"
        },
        {
          "name": "Timothy Caulfield",
          "url": "https://www.speakers.ca/2024/09/timothy-caulfield-on-the-allure-of-pseudoscience-and-how-to-break-its-spell/"
        }
      ]
    },
    {
      "id": "is-a-ketogenic-diet-worth-trying-4tl8",
      "question": "Is a ketogenic diet worth trying, or do its risks outweigh its benefits?",
      "image": "/images/crossfire/is-a-ketogenic-diet-worth-trying-4tl8.webp?v=5538b9fa",
      "people": [
        {
          "name": "Georgia A. Ede",
          "url": "https://www.frontiersin.org/journals/psychiatry/articles/10.3389/fpsyt.2022.951376/full"
        },
        {
          "name": "Neal Barnard",
          "url": "https://www.frontiersin.org/articles/10.3389/fnut.2021.702802/full"
        },
        {
          "name": "Christopher M. Palmer",
          "url": "https://www.psychologytoday.com/us/blog/advancing-psychiatry/201904/chronic-schizophrenia-put-remission-medications"
        }
      ]
    },
    {
      "id": "is-an-all-meat-carnivore-diet-m3u6",
      "question": "Is an all-meat carnivore diet a reasonable thing to try?",
      "image": "/images/crossfire/is-an-all-meat-carnivore-diet-m3u6.webp?v=12490810",
      "people": [
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/dr-shawn-baker-md/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/science-shows-carnivore-diet-best-left-lions"
        }
      ]
    },
    {
      "id": "is-an-injection-of-my-own-1wnt",
      "question": "Is an injection of my own fat-derived stem cells a drug the FDA gets to regulate?",
      "image": "/images/crossfire/is-an-injection-of-my-own-1wnt.webp?v=9edca08f",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/stem-cell-therapy-in-the-united-states-and-the-search-for-the-fountain-of-youth/"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://sciencebasedmedicine.org/stem-cell-clinics-and-unapproved-for-profit-human-experimentation/"
        }
      ]
    },
    {
      "id": "is-a-restricted-daily-eating-window-41ce",
      "question": "Is a restricted daily eating window worth doing?",
      "image": "/images/crossfire/is-a-restricted-daily-eating-window-41ce.webp?v=e880cb11",
      "people": [
        {
          "name": "Nicola Guess",
          "url": "https://drguess.substack.com/p/time-restricted-feeding"
        },
        {
          "name": "Satchidananda Panda",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC8905332/"
        }
      ]
    },
    {
      "id": "is-a-training-programme-enough-or-7nj7",
      "question": "Is a training programme enough, or does the rest of my day have to change?",
      "image": "/images/crossfire/is-a-training-programme-enough-or-7nj7.webp?v=627553da",
      "people": [
        {
          "name": "Katy Bowman",
          "url": "https://podcasts.apple.com/us/podcast/ep-168-is-sitting-aging-you-faster/id894200695?i=1000677606358"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/exercising-for-longevity/"
        }
      ]
    },
    {
      "id": "is-cryopreservation-worth-paying-for-1egl",
      "question": "Is cryopreservation worth paying for?",
      "image": "/images/crossfire/is-cryopreservation-worth-paying-for-1egl.webp?v=e5393e87",
      "people": [
        {
          "name": "Yvette d'Entremont",
          "url": "http://web.archive.org/web/20220224201714id_/https://scibabe.com/daily-mos-the-bullshit-dream-of-cryonics"
        },
        {
          "name": "Max More",
          "url": "https://biostasis.substack.com/p/what-is-the-probability-of-cryonics"
        }
      ]
    },
    {
      "id": "is-cutting-carbs-the-thing-that-1rtu",
      "question": "Is cutting carbs the thing that makes a diet work?",
      "image": "/images/crossfire/is-cutting-carbs-the-thing-that-1rtu.webp?v=480220fe",
      "people": [
        {
          "name": "Christopher D. Gardner",
          "url": "https://jamanetwork.com/journals/jama/fullarticle/2673150"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/a-beginners-introduction-to-the-carnivore-diet/"
        }
      ]
    },
    {
      "id": "is-it-calories-or-is-it-1c8h",
      "question": "Is it calories, or is it insulin?",
      "image": "/images/crossfire/is-it-calories-or-is-it-1c8h.webp?v=93cc3ba5",
      "people": [
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/articles/research/its-not-calories-its-hormones-a-response-to-dr-jason-fung/"
        },
        {
          "name": "Dr. Daniel Pompa",
          "url": null
        }
      ]
    },
    {
      "id": "is-it-ok-to-exercise-in-mphq",
      "question": "Is it OK to exercise in the evening?",
      "image": "/images/crossfire/is-it-ok-to-exercise-in-mphq.webp?v=69ad7cc8",
      "people": [
        {
          "name": "Jade Wu",
          "url": "https://www.drjadewu.com/resources"
        },
        {
          "name": "Matthew Walker",
          "url": "https://themattwalkerpodcast.buzzsprout.com/1821163/episodes/12333701-42-sleep-and-exercise-pt-4"
        }
      ]
    },
    {
      "id": "is-it-worth-buying-organic-produce-ne4d",
      "question": "Is it worth buying organic produce?",
      "image": "/images/crossfire/is-it-worth-buying-organic-produce-ne4d.webp?v=b560b35e",
      "people": [
        {
          "name": "Lara Adler",
          "url": "https://theenergyblueprint.com/laraadler/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/whether-organic-or-not-put-fruit-and-veggies-your-grocery-list"
        }
      ]
    },
    {
      "id": "is-it-worth-paying-more-for-j4h2",
      "question": "Is it worth paying more for organic produce?",
      "image": "/images/crossfire/is-it-worth-paying-more-for-j4h2.webp?v=d66006b1",
      "people": [
        {
          "name": "Aly Cohen",
          "url": "https://thesmarthuman.com/five-more-ways-to-reduce-your-exposure-to-harmful-chemicals/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/whether-organic-or-not-put-fruit-and-veggies-your-grocery-list"
        },
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2012/09/the-new-york-times-online-debate-about-organics/"
        }
      ]
    },
    {
      "id": "is-it-worth-tracking-my-own-419e",
      "question": "Is it worth tracking my own blood sugar responses to decide what to eat?",
      "image": "/images/crossfire/is-it-worth-tracking-my-own-419e.webp?v=38131398",
      "people": [
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/39755436/"
        },
        {
          "name": "Tim Spector",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC11271409/"
        }
      ]
    },
    {
      "id": "is-obesity-caused-by-too-much-1tb8",
      "question": "Is obesity caused by too much insulin, or just by too many calories?",
      "image": "/images/crossfire/is-obesity-caused-by-too-much-1tb8.webp?v=5a57a81b",
      "people": [
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/the-carbohydrate-insulin-hypothesis-is-wrong-hormonal-obesity-vi/"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/33479499/"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/things-ive-changed-my-mind-on-episode-5/"
        }
      ]
    },
    {
      "id": "is-optimising-my-lifestyle-actually-going-l79w",
      "question": "Is optimising my lifestyle actually going to make me live much longer, or is that beside the point?",
      "image": "/images/crossfire/is-optimising-my-lifestyle-actually-going-l79w.webp?v=7d2170b5",
      "people": [
        {
          "name": "Aubrey de Grey",
          "url": "https://blog.insidetracker.com/longevity-by-design-podcast-aubrey-de-grey"
        },
        {
          "name": "Dan Buettner",
          "url": "https://www.bluezones.com/2016/11/power-9/"
        }
      ]
    },
    {
      "id": "is-petroleum-jelly-bad-for-your-oa35",
      "question": "Is petroleum jelly bad for your skin?",
      "image": "/images/crossfire/is-petroleum-jelly-bad-for-your-oa35.webp?v=4cea9385",
      "people": [
        {
          "name": "Darin Olien",
          "url": "https://podcasts.happyscribe.com/the-darin-olien-show/51-fatal-conveniences-petroleum-jelly-skincare-courtesy-of-the-oil-industry"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/quirky-science-you-asked/what-shania-twains-secret-soft-and-supple-skin"
        }
      ]
    },
    {
      "id": "is-plastic-free-laundry-and-dishwasher-1dck",
      "question": "Is 'plastic-free' laundry and dishwasher detergent worth paying more for?",
      "image": "/images/crossfire/is-plastic-free-laundry-and-dishwasher-1dck.webp?v=99f68215",
      "people": [
        {
          "name": "Jessica B. Steier",
          "url": "https://theunbiasedscipod.substack.com/p/dissolving-the-myth"
        },
        {
          "name": "Beatrice Gomberg",
          "url": "https://taborplace.co/blogs/plastic-is-toxic/are-microplastics-the-lead-of-our-generation-10-ways-to-avoid-microplastics"
        }
      ]
    },
    {
      "id": "is-resveratrol-worth-taking-1qq0",
      "question": "Is resveratrol worth taking?",
      "image": "/images/crossfire/is-resveratrol-worth-taking-1qq0.webp?v=a57affb1",
      "people": [
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/nmn-nr-resveratrol-metformin-and-other-molecules-for-longevity/"
        },
        {
          "name": "Matt Kaeberlein",
          "url": "https://podcasters.spotify.com/pod/show/the-optispan-podcast-with/episodes/Debunking-10-Longevity-Myths-You-Still-Believe--126-e37dc9o"
        }
      ]
    },
    {
      "id": "is-saturated-fat-something-i-need-1joy",
      "question": "Is saturated fat something I need to worry about?",
      "image": "/images/crossfire/is-saturated-fat-something-i-need-1joy.webp?v=3fc78502",
      "people": [
        {
          "name": "Rich Roll",
          "url": "https://richroll.com/blog/coconut-oil-panacea-or-artery-clogger/"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/carnivore-diet-side-effects/"
        }
      ]
    },
    {
      "id": "is-spontaneous-desire-the-standard-a-i4mm",
      "question": "Is spontaneous desire the standard a healthy long-term relationship should try to restore?",
      "image": "/images/crossfire/is-spontaneous-desire-the-standard-a-i4mm.webp?v=d2bc0351",
      "people": [
        {
          "name": "Emily Nagoski",
          "url": "https://www.pushkin.fm/podcasts/come-as-you-are/how-desire-actually-works"
        },
        {
          "name": "Esther Perel",
          "url": "https://www.ted.com/talks/esther_perel_the_secret_to_desire_in_a_long_term_relationship"
        }
      ]
    },
    {
      "id": "is-sugar-the-problem-or-is-rf68",
      "question": "Is sugar the problem, or is it just calories?",
      "image": "/images/crossfire/is-sugar-the-problem-or-is-rf68.webp?v=684b8787",
      "people": [
        {
          "name": "Alan Aragon",
          "url": "https://www.alanaragonblog.com/2010/01/29/the-bitter-truth-about-fructose-alarmism/"
        },
        {
          "name": "Robert H. Lustig",
          "url": "https://uctv.tv/shows/Sugar-The-Bitter-Truth-16717"
        }
      ]
    },
    {
      "id": "is-the-10-percent-cap-on-1epj",
      "question": "Is the 10 percent cap on saturated fat worth following?",
      "image": "/images/crossfire/is-the-10-percent-cap-on-1epj.webp?v=eaae6e2e",
      "people": [
        {
          "name": "Joel Kahn",
          "url": "https://www.kahnlongevitycenter.com/blog/what-do-medical-societies-worldwide-advise-for-saturated-fat-intake"
        },
        {
          "name": "Nina Teicholz",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9794145/"
        }
      ]
    },
    {
      "id": "is-the-bisphenol-a-in-food-1ruz",
      "question": "Is the bisphenol A in food packaging harmful at the levels people are actually exposed to?",
      "image": "/images/crossfire/is-the-bisphenol-a-in-food-1ruz.webp?v=9590355b",
      "people": [
        {
          "name": "John Peterson Myers",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC2661896/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/health-news/majestically-scientific-study-casts-doubt-risks-associated-bisphenol"
        }
      ]
    },
    {
      "id": "is-the-black-plastic-in-my-1a1g",
      "question": "Is the black plastic in my kitchen dangerous?",
      "image": "/images/crossfire/is-the-black-plastic-in-my-1a1g.webp?v=cfe81313",
      "people": [
        {
          "name": "Beatrice Gomberg",
          "url": "https://taborplace.co/blogs/plastic-is-toxic/black-plastic-has-lead-toxic-flame-retardants-and-your-coffee-maker-is-probably-made-out-of-it"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/are-black-plastic-spatulas-and-serving-spoons-safe-use"
        },
        {
          "name": "Michelle Wong",
          "url": "https://labmuffin.com/plastic-free-is-the-new-clean-beauty/"
        }
      ]
    },
    {
      "id": "is-the-plastic-in-my-food-c058",
      "question": "Is the plastic in my food and water doing me harm at the amounts I actually get?",
      "image": "/images/crossfire/is-the-plastic-in-my-food-c058.webp?v=7bd16cd5",
      "people": [
        {
          "name": "Shanna H. Swan",
          "url": "https://pubmed.ncbi.nlm.nih.gov/16079079/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/macropanic-over-nanoplastics"
        }
      ]
    },
    {
      "id": "is-there-a-level-of-drinking-10mx",
      "question": "Is there a level of drinking that is good for you, or only levels that are less bad?",
      "image": "/images/crossfire/is-there-a-level-of-drinking-10mx.webp?v=bcb82e22",
      "people": [
        {
          "name": "Tim Stockwell",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC10066463/"
        },
        {
          "name": "Kenneth J. Mukamal",
          "url": "https://www.harvardmagazine.com/2025/01/harvard-study-how-much-alcohol-is-safe"
        },
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2026/01/maha-dietary-guidelines-v-the-alcohol-non-recommendation/"
        }
      ]
    },
    {
      "id": "is-there-a-level-of-these-1him",
      "question": "Is there a level of these chemicals low enough to be safe?",
      "image": "/images/crossfire/is-there-a-level-of-these-1him.webp?v=2dcce2aa",
      "people": [
        {
          "name": "Bruce Lanphear",
          "url": "https://erictopol.substack.com/p/is-chronic-lead-exposure-a-risk-factor"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/are-black-plastic-spatulas-and-serving-spoons-safe-use"
        }
      ]
    },
    {
      "id": "is-there-a-pill-that-boosts-1foc",
      "question": "Is there a pill that boosts my stem cells?",
      "image": "/images/crossfire/is-there-a-pill-that-boosts-1foc.webp?v=84cf8e3e",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/7-reasons-youre-aging-faster-than-you-should-be/"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://ipscell.com/2024/09/new-review-of-stem-cell-supplements-and-pills/"
        }
      ]
    },
    {
      "id": "is-there-a-test-that-tells-rtfi",
      "question": "Is there a test that tells me whether low-carb is right for me?",
      "image": "/images/crossfire/is-there-a-test-that-tells-rtfi.webp?v=ca95fff4",
      "people": [
        {
          "name": "Benjamin T. Bikman",
          "url": "https://benbikman.com/heart-disease-markers-that-matter/"
        },
        {
          "name": "Christopher D. Gardner",
          "url": "https://pubmed.ncbi.nlm.nih.gov/29466592/"
        }
      ]
    },
    {
      "id": "is-ultra-processed-a-useful-thing-2joi",
      "question": "Is 'ultra-processed' a useful thing to avoid, or just a label?",
      "image": "/images/crossfire/is-ultra-processed-a-useful-thing-2joi.webp?v=ad57d807",
      "people": [
        {
          "name": "Nina Teicholz",
          "url": "https://unsettledscience.substack.com/p/junk-food-has-been-rebranded-as-ultra"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/31105044/"
        }
      ]
    },
    {
      "id": "is-ultra-processed-food-a-category-1u5g",
      "question": "Is \"ultra-processed food\" a category you can actually shop by?",
      "image": "/images/crossfire/is-ultra-processed-food-a-category-1u5g.webp?v=b5131803",
      "people": [
        {
          "name": "Yvette d'Entremont",
          "url": "http://web.archive.org/web/20250106233632id_/https://scibabe.com/mos-ultra-processed-food"
        },
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2026/05/ultra-processed-food-defined-not-all-that-complicated/"
        }
      ]
    },
    {
      "id": "is-ultra-processed-food-addictive-or-1bgi",
      "question": "Is ultra-processed food addictive, or is that the wrong word for it?",
      "image": "/images/crossfire/is-ultra-processed-food-addictive-or-1bgi.webp?v=3012963b",
      "people": [
        {
          "name": "Robert H. Lustig",
          "url": "https://pubmed.ncbi.nlm.nih.gov/40950761/"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/39108535/"
        }
      ]
    },
    {
      "id": "is-zone-2-a-special-intensity-100f",
      "question": "Is Zone 2 a special intensity that produces adaptations nothing else can?",
      "image": "/images/crossfire/is-zone-2-a-special-intensity-100f.webp?v=0808b865",
      "people": [
        {
          "name": "Stephen Seiler",
          "url": "https://www.ebi.ac.uk/europepmc/webservices/rest/search?query=DOI:%2210.1123/ijspp.2024-0303%22&format=json&resultType=core&pageSize=1"
        },
        {
          "name": "Iñigo San Millán",
          "url": "https://inigosanmillan.substack.com/p/zone-2-is-a-metabolic-equilibrium"
        }
      ]
    },
    {
      "id": "my-cholesterol-came-back-high-do-6jd0",
      "question": "My cholesterol came back high. Do I treat the number, or find out why it is high?",
      "image": "/images/crossfire/my-cholesterol-came-back-high-do-6jd0.webp?v=d1254a2d",
      "people": [
        {
          "name": "Mark Hyman",
          "url": "https://drhyman.com/blogs/content/podcast-ep1148"
        },
        {
          "name": "Simon Hill",
          "url": "https://theproof.com/wp-content/uploads/2023/06/TP_LipidCheatSheet.pdf"
        }
      ]
    },
    {
      "id": "my-cholesterol-went-up-on-this-zp4w",
      "question": "My cholesterol went up on this diet. Does it matter?",
      "image": "/images/crossfire/my-cholesterol-went-up-on-this-zp4w.webp?v=60ee37fe",
      "people": [
        {
          "name": "Simon Hill",
          "url": "https://theproof.com/does-ldl-particle-size-matter/"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/carnivore-diet-side-effects/"
        }
      ]
    },
    {
      "id": "my-gut-hurts-should-i-eat-14yc",
      "question": "My gut hurts. Should I eat more fibre or less?",
      "image": "/images/crossfire/my-gut-hurts-should-i-eat-14yc.webp?v=a726256c",
      "people": [
        {
          "name": "Will Bulsiewicz",
          "url": "https://zoe.com/learn/why-understanding-sibo-could-improve-your-health"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/a-beginners-introduction-to-the-carnivore-diet/"
        }
      ]
    },
    {
      "id": "my-ldl-cholesterol-went-up-on-3ox6",
      "question": "My LDL cholesterol went up on a ketogenic diet. Is that a problem?",
      "image": "/images/crossfire/my-ldl-cholesterol-went-up-on-3ox6.webp?v=e0c4d1ee",
      "people": [
        {
          "name": "Stephen D. Phinney",
          "url": "https://www.virtahealth.com/blog/blood-lipid-changes-with-ketogenic-diet"
        },
        {
          "name": "Christopher D. Gardner",
          "url": "https://pubmed.ncbi.nlm.nih.gov/35641199/"
        }
      ]
    },
    {
      "id": "on-a-low-carb-diet-do-1vqx",
      "question": "On a low-carb diet, do you still need vegetables and fibre?",
      "image": "/images/crossfire/on-a-low-carb-diet-do-1vqx.webp?v=bdcdf1d3",
      "people": [
        {
          "name": "Dominic P. D'Agostino",
          "url": "https://tim.blog/2026/01/06/ketosis-practical-guide-dom-dagostino/"
        },
        {
          "name": "Shawn Baker",
          "url": "https://carnivore.diet/"
        }
      ]
    },
    {
      "id": "once-you-are-past-the-minimum-1vog",
      "question": "Once you are past the minimum, does adding more sets keep building muscle?",
      "image": "/images/crossfire/once-you-are-past-the-minimum-1vog.webp?v=9b8e90c9",
      "people": [
        {
          "name": "Jeff Nippard",
          "url": "https://www.youtube.com/watch?v=jeZb2gvsahQ"
        },
        {
          "name": "Mike Israetel",
          "url": "https://rpstrength.com/blogs/articles/progressing-for-hypertrophy"
        }
      ]
    },
    {
      "id": "should-a-healthy-adult-take-an-uwby",
      "question": "Should a healthy adult take an NAD booster (NMN or NR) to slow aging?",
      "image": "/images/crossfire/should-a-healthy-adult-take-an-uwby.webp?v=de83d0ec",
      "people": [
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/nmn-and-exercise-performance/"
        },
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/nmn-nr-resveratrol-metformin-and-other-molecules-for-longevity/"
        }
      ]
    },
    {
      "id": "should-a-healthy-person-without-diabetes-ctw4",
      "question": "Should a healthy person without diabetes take metformin to slow ageing?",
      "image": "/images/crossfire/should-a-healthy-person-without-diabetes-ctw4.webp?v=8be2be0b",
      "people": [
        {
          "name": "Siim Land",
          "url": "https://www.siimland.co/my-longevity-routine,"
        },
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/nmn-nr-resveratrol-metformin-and-other-molecules-for-longevity/,"
        }
      ]
    },
    {
      "id": "should-a-healthy-young-adult-routinely-12qz",
      "question": "Should a healthy young adult routinely receive each updated COVID-19 vaccine?",
      "image": "/images/crossfire/should-a-healthy-young-adult-routinely-12qz.webp?v=b5435ed7",
      "people": [
        {
          "name": "Katelyn Jetelina",
          "url": "https://yourlocalepidemiologist.substack.com/p/a-guide-to-fall-2025-vaccines"
        },
        {
          "name": "Vinay Prasad",
          "url": "https://www.sensible-med.com/p/no-a-healthy-20-year-old-man-who"
        }
      ]
    },
    {
      "id": "should-families-use-firm-age-rules-18er",
      "question": "Should families use firm age rules for smartphones and social media?",
      "image": "/images/crossfire/should-families-use-firm-age-rules-18er.webp?v=3bd54893",
      "people": [
        {
          "name": "Jonathan Haidt",
          "url": "https://www.anxiousgeneration.com/"
        },
        {
          "name": "Amy Orben",
          "url": "https://www.cam.ac.uk/stories/socialmedia"
        }
      ]
    },
    {
      "id": "should-i-avoid-a-food-because-pjds",
      "question": "Should I avoid a food because it's ultra-processed?",
      "image": "/images/crossfire/should-i-avoid-a-food-because-pjds.webp?v=ef7f7d66",
      "people": [
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2026/06/public-health-series-on-ultraprocessed-foods-my-editorial/"
        },
        {
          "name": "Giles Yeo",
          "url": "https://www.theguardian.com/commentisfree/2024/mar/06/ultra-processed-food-healthy-diets-pr"
        }
      ]
    },
    {
      "id": "should-i-avoid-the-common-chemical-1g59",
      "question": "Should I avoid the common chemical sunscreen filters and use mineral only?",
      "image": "/images/crossfire/should-i-avoid-the-common-chemical-1g59.webp?v=2b3dc253",
      "people": [
        {
          "name": "Yvonne Burkart",
          "url": "https://dryvonneburkart.com/6-surprising-truths-about-sunscreen-what-every-health-conscious-person-should-know/"
        },
        {
          "name": "Michelle Wong",
          "url": "https://labmuffin.com/sunscreens-in-your-blood-that-fda-study/"
        }
      ]
    },
    {
      "id": "should-i-bank-stem-cells-now-192a",
      "question": "Should I bank stem cells now, while mine are the youngest they will ever be?",
      "image": "/images/crossfire/should-i-bank-stem-cells-now-192a.webp?v=1cf57218",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/stem-cell-therapy-in-the-united-states-and-the-search-for-the-fountain-of-youth/"
        },
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/medical-interventions-trt-hgh-stem-cells-etc-for-longevity/"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://ipscell.com/2021/01/fact-checking-pros-and-cons-of-cord-blood-banking/"
        }
      ]
    },
    {
      "id": "should-i-be-adding-salt-to-1q1s",
      "question": "Should I be adding salt to my food, or cutting it?",
      "image": "/images/crossfire/should-i-be-adding-salt-to-1q1s.webp?v=ec87bace",
      "people": [
        {
          "name": "Stephen D. Phinney",
          "url": "https://www.virtahealth.com/blog/sodium-nutritional-ketosis-keto-flu-adrenal-function"
        },
        {
          "name": "Gil Carvalho",
          "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified"
        }
      ]
    },
    {
      "id": "should-i-be-eating-nuts-seeds-1dtg",
      "question": "Should I be eating nuts, seeds and avocados?",
      "image": "/images/crossfire/should-i-be-eating-nuts-seeds-1dtg.webp?v=8a989684",
      "people": [
        {
          "name": "Neal Barnard",
          "url": "https://www.pcrm.org/clinical-research/fighting-hot-flashes-with-diet"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/daily-dozen/"
        }
      ]
    },
    {
      "id": "should-i-be-preparing-for-my-y98f",
      "question": "Should I be preparing for my death, or trying to avoid it?",
      "image": "/images/crossfire/should-i-be-preparing-for-my-y98f.webp?v=68b35e0e",
      "people": [
        {
          "name": "BJ Miller",
          "url": "https://www.ted.com/talks/bj_miller_what_really_matters_at_the_end_of_life/transcript"
        },
        {
          "name": "Max More",
          "url": "https://biostasis.substack.com/p/biostasis-longevity-plan-a"
        }
      ]
    },
    {
      "id": "should-i-be-told-what-bad-om1j",
      "question": "Should I be told what bad sleep is doing to me?",
      "image": "/images/crossfire/should-i-be-told-what-bad-om1j.webp?v=77d2c407",
      "people": [
        {
          "name": "Shelby Harris",
          "url": "https://drshelbyharris.com/why-sleep-matters/"
        },
        {
          "name": "Jade Wu",
          "url": "https://www.drjadewu.com/resources"
        }
      ]
    },
    {
      "id": "should-i-be-trying-to-raise-1en5",
      "question": "Should I be trying to raise my VO2 max?",
      "image": "/images/crossfire/should-i-be-trying-to-raise-1en5.webp?v=59e6979f",
      "people": [
        {
          "name": "Eric Topol",
          "url": "https://erictopol.substack.com/p/the-flawed-v02-max-craze"
        },
        {
          "name": "Peter Attia",
          "url": "https://peterattiamd.com/how-does-vo2-max-correlate-with-longevity/"
        }
      ]
    },
    {
      "id": "should-i-choose-a-mineral-sunscreen-1ori",
      "question": "Should I choose a mineral sunscreen over a chemical one?",
      "image": "/images/crossfire/should-i-choose-a-mineral-sunscreen-1ori.webp?v=a86b452c",
      "people": [
        {
          "name": "Leslie Baumann",
          "url": "https://skintypesolutions.com/blogs/skincare/sunscreen-basics"
        },
        {
          "name": "Michelle Wong",
          "url": "https://labmuffin.com/factcheck-low-tox-sunscreen-swaps/"
        }
      ]
    },
    {
      "id": "should-i-cut-out-gluten-even-pbx4",
      "question": "Should I cut out gluten even though I do not have coeliac disease?",
      "image": "/images/crossfire/should-i-cut-out-gluten-even-pbx4.webp?v=cc3896dd",
      "people": [
        {
          "name": "Mark Hyman",
          "url": "https://drhyman.com/blogs/content/to-gluten-or-not-to-gluten"
        },
        {
          "name": "Food Science Babe",
          "url": "https://www.agdaily.com/crops/wheat-myths-and-sensitivities-to-gluten/"
        }
      ]
    },
    {
      "id": "should-i-fast-for-16-hours-1tep",
      "question": "Should I fast for 16 hours a day?",
      "image": "/images/crossfire/should-i-fast-for-16-hours-1tep.webp?v=32e58ea4",
      "people": [
        {
          "name": "Valter Longo",
          "url": "https://www.fondazionevalterlongo.org/wp-content/uploads/2024/02/2024-01_fondazione-longo_digiuno-e-longevita-EN-libro.pdf"
        },
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/what-to-eat-when-to-eat-for-longevity/"
        },
        {
          "name": "Layne Norton",
          "url": "https://www.hubermanlab.com/episode/dr-layne-norton-tools-for-nutrition-fitness"
        },
        {
          "name": "Stacy T. Sims",
          "url": null
        },
        {
          "name": "Satchidananda Panda",
          "url": "https://www.hubermanlab.com/episode/dr-satchin-panda-intermittent-fasting-to-improve-health-cognition-and-longevity"
        },
        {
          "name": "Dr. Daniel Pompa",
          "url": "https://drpompa.com/fasting/intermittent-fasting-top-5-strategies-for-your-best-health-ever/"
        }
      ]
    },
    {
      "id": "should-i-get-a-biological-age-qfe8",
      "question": "Should I get a biological age test?",
      "image": "/images/crossfire/should-i-get-a-biological-age-qfe8.webp?v=06e96ca3",
      "people": [
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/biotracking-age-reversal-other-advanced-health-technologies/"
        },
        {
          "name": "Matt Kaeberlein",
          "url": "https://podcasters.spotify.com/pod/show/the-optispan-podcast-with/episodes/The-Truth-About-Biological-Age-Tests--104-e3018k9"
        }
      ]
    },
    {
      "id": "should-i-get-a-flu-shot-1vzf",
      "question": "Should I get a flu shot every year?",
      "image": "/images/crossfire/should-i-get-a-flu-shot-1vzf.webp?v=2d1c30af",
      "people": [
        {
          "name": "Andrea Love",
          "url": "https://news.immunologic.org/p/everyone-6-months-and-older-should"
        },
        {
          "name": "Andrew D. Huberman",
          "url": "https://www.hubermanlab.com/episode/how-to-prevent-treat-colds-flu"
        }
      ]
    },
    {
      "id": "should-i-have-a-target-weight-zcs9",
      "question": "Should I have a target weight?",
      "image": "/images/crossfire/should-i-have-a-target-weight-zcs9.webp?v=8b54f90a",
      "people": [
        {
          "name": "Valter Longo",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9089818/"
        },
        {
          "name": "Giles Yeo",
          "url": "https://www.sciencefocus.com/comment/bmi-we-know-its-flawed-so-why-do-we-still-use-it"
        }
      ]
    },
    {
      "id": "should-i-keep-protein-low-to-qjf8",
      "question": "Should I keep protein low to live longer?",
      "image": "/images/crossfire/should-i-keep-protein-low-to-qjf8.webp?v=b5982a39",
      "people": [
        {
          "name": "Gil Carvalho",
          "url": "https://podcast.clearerthinking.org/episode/212/gil-carvalho-what-we-know-and-don-t-know-about-nutrition/,"
        },
        {
          "name": "Valter Longo",
          "url": "https://valterlongo.com/daily-longevity-diet-for-adults/,"
        }
      ]
    },
    {
      "id": "should-i-optimise-my-sleep-or-l2fu",
      "question": "Should I optimise my sleep, or stop trying so hard?",
      "image": "/images/crossfire/should-i-optimise-my-sleep-or-l2fu.webp?v=505db031",
      "people": [
        {
          "name": "Matthew Walker",
          "url": "https://www.sleepdiplomat.com/"
        },
        {
          "name": "Jade Wu",
          "url": "https://www.drjadewu.com/"
        }
      ]
    },
    {
      "id": "should-i-pay-a-clinic-for-igpl",
      "question": "Should I pay a clinic for a stem cell treatment?",
      "image": "/images/crossfire/should-i-pay-a-clinic-for-igpl.webp?v=9f018f64",
      "people": [
        {
          "name": "Timothy Caulfield",
          "url": "https://pubmed.ncbi.nlm.nih.gov/28679655/"
        },
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/how-adult-stem-cells-can-help-stop-pain-and-reverse-aging/"
        }
      ]
    },
    {
      "id": "should-i-put-back-a-food-dyq1",
      "question": "Should I put back a food because the ingredient list is long or full of words I can't say?",
      "image": "/images/crossfire/should-i-put-back-a-food-dyq1.webp?v=0080fd44",
      "people": [
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2010/12/latest-san-francisco-chronicle-column-processed-v-real-foods/"
        },
        {
          "name": "Giles Yeo",
          "url": "https://www.sciencefocus.com/the-human-body/weight-loss-myths"
        }
      ]
    },
    {
      "id": "should-i-replace-my-plastic-kitchen-74bf",
      "question": "Should I replace my plastic kitchen and personal care items?",
      "image": "/images/crossfire/should-i-replace-my-plastic-kitchen-74bf.webp?v=fccb17be",
      "people": [
        {
          "name": "Beatrice Gomberg",
          "url": "https://taborplace.co/blogs/plastic-is-toxic/black-plastic-has-lead-toxic-flame-retardants-and-your-coffee-maker-is-probably-made-out-of-it"
        },
        {
          "name": "Michelle Wong",
          "url": "https://www.tiktok.com/@labmuffinbeautyscience/video/7491097451638590727"
        }
      ]
    },
    {
      "id": "should-i-skip-breakfast-12io",
      "question": "Should I skip breakfast?",
      "image": "/images/crossfire/should-i-skip-breakfast-12io.webp?v=a87bbc4f",
      "people": [
        {
          "name": "Tim Spector",
          "url": "https://theconversation.com/skipping-breakfast-may-help-you-lose-weight-what-hunter-gatherers-can-teach-us-109840"
        },
        {
          "name": "Valter Longo",
          "url": "https://www.fondazionevalterlongo.org/wp-content/uploads/2024/02/2024-01_fondazione-longo_digiuno-e-longevita-EN-libro.pdf"
        }
      ]
    },
    {
      "id": "should-i-stop-cooking-with-sunflower-s959",
      "question": "Should I stop cooking with sunflower, soybean, corn or cottonseed oil?",
      "image": "/images/crossfire/should-i-stop-cooking-with-sunflower-s959.webp?v=07bf09a8",
      "people": [
        {
          "name": "Robert H. Lustig",
          "url": "https://robertlustig.com/m-plus-app/"
        },
        {
          "name": "Food Science Babe",
          "url": "https://www.agdaily.com/insights/inflammatory-unhealthy-false-claims-made-about-seed-oil/"
        }
      ]
    },
    {
      "id": "should-i-switch-away-from-my-1jjg",
      "question": "Should I switch away from my aluminium antiperspirant?",
      "image": "/images/crossfire/should-i-switch-away-from-my-1jjg.webp?v=52d8f103",
      "people": [
        {
          "name": "Aly Cohen",
          "url": "https://thesmarthuman.com/household-items-you-should-throw-away-now/"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/health-you-asked/there-any-risk-using-antiperspirants-or-deodorants"
        }
      ]
    },
    {
      "id": "should-i-take-an-nad-booster-fstp",
      "question": "Should I take an NAD booster like NMN?",
      "image": "/images/crossfire/should-i-take-an-nad-booster-fstp.webp?v=2cc549d1",
      "people": [
        {
          "name": "David A. Sinclair",
          "url": "https://www.lifespanpodcast.com/nmn-nr-resveratrol-metformin-and-other-molecules-for-longevity/"
        },
        {
          "name": "Matt Kaeberlein",
          "url": "https://podcasters.spotify.com/pod/show/the-optispan-podcast-with/episodes/Everything-I-do-for-Healthspan-and-why-I-skip-THESE-Supplements-e3dbv47"
        }
      ]
    },
    {
      "id": "should-i-take-creatine-after-menopause-1o1n",
      "question": "Should I take creatine after menopause?",
      "image": "/images/crossfire/should-i-take-creatine-after-menopause-1o1n.webp?v=147a5a3b",
      "people": [
        {
          "name": "Stacy T. Sims",
          "url": "https://pubmed.ncbi.nlm.nih.gov/37221858/"
        },
        {
          "name": "Jennifer Gunter",
          "url": "https://vajenda.substack.com/p/should-every-woman-in-menopause-take"
        },
        {
          "name": "Mary Claire Haver",
          "url": "https://drmaryclairehaver.substack.com/p/the-toolkit"
        }
      ]
    },
    {
      "id": "should-i-take-hormone-therapy-to-18sp",
      "question": "Should I take hormone therapy to prevent disease, or only to treat symptoms?",
      "image": "/images/crossfire/should-i-take-hormone-therapy-to-18sp.webp?v=7e5a98f5",
      "people": [
        {
          "name": "Mary Claire Haver",
          "url": "https://drmaryclairehaver.substack.com/p/the-new-menopause-why-hormone-care"
        },
        {
          "name": "Jennifer Gunter",
          "url": "https://vajenda.substack.com/p/why-did-a-reasonable-menopause-article"
        }
      ]
    },
    {
      "id": "should-i-throw-out-my-black-1bj2",
      "question": "Should I throw out my black plastic kitchen utensils?",
      "image": "/images/crossfire/should-i-throw-out-my-black-1bj2.webp?v=e180993f",
      "people": [
        {
          "name": "Beatrice Gomberg",
          "url": "https://taborplace.co/blogs/plastic-is-toxic/black-plastic-has-lead-toxic-flame-retardants-and-your-coffee-maker-is-probably-made-out-of-it"
        },
        {
          "name": "Joe Schwarcz",
          "url": "https://www.mcgill.ca/oss/article/critical-thinking-health-and-nutrition/are-black-plastic-spatulas-and-serving-spoons-safe-use"
        }
      ]
    },
    {
      "id": "should-i-time-my-fasting-to-4u28",
      "question": "Should I time my fasting to the phase of my menstrual cycle?",
      "image": "/images/crossfire/should-i-time-my-fasting-to-4u28.webp?v=8ee29634",
      "people": [
        {
          "name": "Mindy Hetzer Pelz",
          "url": "https://www.drmindypelz.com/how-long-to-fast-during-your-cycle"
        },
        {
          "name": "Stacy T. Sims",
          "url": "https://www.drstacysims.com/newsletters/articles/posts/the-evolution-of-menstrual-cycle-training"
        }
      ]
    },
    {
      "id": "should-i-use-a-glucose-monitor-gnec",
      "question": "Should I use a glucose monitor to decide which foods are right for me?",
      "image": "/images/crossfire/should-i-use-a-glucose-monitor-gnec.webp?v=47f25269",
      "people": [
        {
          "name": "Casey Means",
          "url": "https://www.levels.com/blog/7-reasons-dr-casey-means-believes-in-cgm"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/39755436/"
        }
      ]
    },
    {
      "id": "should-nutrition-scientists-take-money-from-1ixl",
      "question": "Should nutrition scientists take money from food companies?",
      "image": "/images/crossfire/should-nutrition-scientists-take-money-from-1ixl.webp?v=b8de3dd3",
      "people": [
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2017/08/should-nutrition-scientists-take-food-industry-funding/"
        },
        {
          "name": "Dariush Mozaffarian",
          "url": "https://www.nature.com/articles/s43016-021-00381-y"
        }
      ]
    },
    {
      "id": "should-pregnant-women-avoid-folic-acid-wtea",
      "question": "Should pregnant women avoid folic acid in favour of methylfolate?",
      "image": "/images/crossfire/should-pregnant-women-avoid-folic-acid-wtea.webp?v=99580c30",
      "people": [
        {
          "name": "Dr Idrees Hamid Mughal",
          "url": "https://www.foodfacts.org/articles/paul-saladino-folic-acid-prenatal-vitamins-evidence-guidelines"
        },
        {
          "name": "Paul Gregory Saladino",
          "url": null
        }
      ]
    },
    {
      "id": "should-women-fast-the-same-way-1lft",
      "question": "Should women fast the same way men do?",
      "image": "/images/crossfire/should-women-fast-the-same-way-1lft.webp?v=0e3b689a",
      "people": [
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/women-and-fasting-part-10/"
        },
        {
          "name": "Stacy T. Sims",
          "url": "https://www.drstacysims.com/newsletters/articles/posts/You_are_an_athlete_and_you_shouldnt_practice_intermittent_fasting"
        },
        {
          "name": "Satchidananda Panda",
          "url": "https://www.hubermanlab.com/episode/dr-satchin-panda-intermittent-fasting-to-improve-health-cognition-and-longevity"
        },
        {
          "name": "Dr. Daniel Pompa",
          "url": "https://drpompa.com/fasting/women-fasting/,"
        }
      ]
    },
    {
      "id": "should-women-plan-training-around-the-iks5",
      "question": "Should women plan training around the phase of the menstrual cycle?",
      "image": "/images/crossfire/should-women-plan-training-around-the-iks5.webp?v=2c7de8d9",
      "people": [
        {
          "name": "Bryan Johnson",
          "url": "https://protocol.bryanjohnson.com/"
        },
        {
          "name": "Stacy T. Sims",
          "url": "https://www.drstacysims.com/newsletters/articles/posts/the-evolution-of-menstrual-cycle-training"
        }
      ]
    },
    {
      "id": "should-you-add-sets-every-week-1npq",
      "question": "Should you add sets every week, or only when your lifts stop improving?",
      "image": "/images/crossfire/should-you-add-sets-every-week-1npq.webp?v=b744a717",
      "people": [
        {
          "name": "Eric Helms",
          "url": "https://massresearchreview.com/2023/05/22/a-progression-framework-for-hypertrophy/"
        },
        {
          "name": "Mike Israetel",
          "url": "https://rpstrength.com/blogs/articles/training-volume-landmarks-muscle-growth"
        }
      ]
    },
    {
      "id": "should-you-avoid-tylenol-in-pregnancy-1uyz",
      "question": "Should you avoid Tylenol in pregnancy?",
      "image": "/images/crossfire/should-you-avoid-tylenol-in-pregnancy-1uyz.webp?v=2304efce",
      "people": [
        {
          "name": "Aviva Romm",
          "url": "https://avivaromm.com/tylenol-headaches-in-pregnancy/"
        },
        {
          "name": "Paul Gregory Saladino",
          "url": "https://www.paulsaladinomd.com/psmd-newsletters/debunking-the-debunking-of-tylenol-autism"
        }
      ]
    },
    {
      "id": "should-you-buy-a-test-that-flv9",
      "question": "Should you buy a test that tells you how fast you are ageing?",
      "image": "/images/crossfire/should-you-buy-a-test-that-flv9.webp?v=112b5286",
      "people": [
        {
          "name": "Bryan Johnson",
          "url": "https://blueprint.bryanjohnson.com/pages/biomarkers"
        },
        {
          "name": "Matt Kaeberlein",
          "url": "https://podcasters.spotify.com/pod/show/the-optispan-podcast-with/episodes/The-Truth-About-Biological-Age-Tests--104-e3018k9"
        }
      ]
    },
    {
      "id": "should-you-cook-with-olive-oil-1qav",
      "question": "Should you cook with olive oil, or with no added oil at all?",
      "image": "/images/crossfire/should-you-cook-with-olive-oil-1qav.webp?v=08ca7caf",
      "people": [
        {
          "name": "Joel H. Fuhrman",
          "url": "https://www.drfuhrman.com/podcast/20/14-habits,"
        },
        {
          "name": "Valter Longo",
          "url": "https://valterlongo.com/daily-longevity-diet-for-adults/,"
        }
      ]
    },
    {
      "id": "should-you-cook-with-seed-oils-13b4",
      "question": "Should you cook with seed oils, or replace them with olive oil, ghee and tallow?",
      "image": "/images/crossfire/should-you-cook-with-seed-oils-13b4.webp?v=dbc4dfb8",
      "people": [
        {
          "name": "Ben Greenfield",
          "url": "https://bengreenfieldlife.com/article/avoid-seed-oils-choose-healthy-fats-instead/"
        },
        {
          "name": "Gil Carvalho",
          "url": "https://gilcarvalhomdphd.substack.com/p/30-years-of-nutrition-knowledge-simplified"
        }
      ]
    },
    {
      "id": "should-you-distrust-a-study-because-bcaf",
      "question": "Should you distrust a study because a company paid for it?",
      "image": "/images/crossfire/should-you-distrust-a-study-because-bcaf.webp?v=39579ac2",
      "people": [
        {
          "name": "Alan Aragon",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12265102/"
        },
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2017/08/should-nutrition-scientists-take-food-industry-funding/"
        }
      ]
    },
    {
      "id": "should-you-eat-more-salt-or-1gxp",
      "question": "Should you eat more salt or less?",
      "image": "/images/crossfire/should-you-eat-more-salt-or-1gxp.webp?v=e0e8d964",
      "people": [
        {
          "name": "Ken D. Berry",
          "url": "https://drberry.com/pages/proper-human-diet"
        },
        {
          "name": "Michael Greger",
          "url": "https://nutritionfacts.org/video/salt-of-the-earth-sodium-and-plant-based-diets/"
        }
      ]
    },
    {
      "id": "should-you-fast-for-longer-than-1d09",
      "question": "Should you fast for longer than a day?",
      "image": "/images/crossfire/should-you-fast-for-longer-than-1d09.webp?v=920a3882",
      "people": [
        {
          "name": "Eric Charles Westman",
          "url": "https://adaptyourlifeacademy.com/dr-eric-westman/how-much-protein-do-you-need/"
        },
        {
          "name": "Jason Fung",
          "url": "https://www.thefastingmethod.com/longer-fasting-regimens-part-7/"
        }
      ]
    },
    {
      "id": "should-you-get-your-vitamin-d-1ard",
      "question": "Should you get your vitamin D level tested, and what number should you aim for?",
      "image": "/images/crossfire/should-you-get-your-vitamin-d-1ard.webp?v=f0999c07",
      "people": [
        {
          "name": "Rhonda Patrick",
          "url": "https://www.foundmyfitness.com/episodes/optimal-vitamin-d-dose,"
        },
        {
          "name": "Andrea Love",
          "url": "https://news.immunologic.org/p/vitamin-d-can-we-finally-stop-beating,"
        }
      ]
    },
    {
      "id": "should-you-stop-using-chemical-sunscreen-8jvp",
      "question": "Should you stop using chemical sunscreen?",
      "image": "/images/crossfire/should-you-stop-using-chemical-sunscreen-8jvp.webp?v=cc7dfa6f",
      "people": [
        {
          "name": "Paul Gregory Saladino",
          "url": "https://www.paulsaladinomd.com/psmd-newsletters/avoid-sunscreen-do-this-instead"
        },
        {
          "name": "Leslie Baumann",
          "url": "https://skintypesolutions.com/blogs/skincare/sunscreen-safety"
        }
      ]
    },
    {
      "id": "should-you-swap-butter-for-vegetable-1qj4",
      "question": "Should you swap butter for vegetable oil?",
      "image": "/images/crossfire/should-you-swap-butter-for-vegetable-1qj4.webp?v=65bcf2b3",
      "people": [
        {
          "name": "Dariush Mozaffarian",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC4814348/"
        },
        {
          "name": "Nina Teicholz",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC9794145/"
        }
      ]
    },
    {
      "id": "should-you-take-an-easy-week-ibpp",
      "question": "Should you take an easy week or a week off from training every month or two?",
      "image": "/images/crossfire/should-you-take-an-easy-week-ibpp.webp?v=6605d40d",
      "people": [
        {
          "name": "Mike Israetel",
          "url": "https://rpstrength.com/blogs/articles/training-volume-landmarks-muscle-growth"
        },
        {
          "name": "Brad Schoenfeld",
          "url": "https://pubmed.ncbi.nlm.nih.gov/38274324/"
        }
      ]
    },
    {
      "id": "should-you-train-your-back-to-wm0b",
      "question": "Should you train your back to round under load, or keep a loaded spine stiff?",
      "image": "/images/crossfire/should-you-train-your-back-to-wm0b.webp?v=f582c13f",
      "people": [
        {
          "name": "Stuart McGill",
          "url": "https://www.backfitpro.com/documents/Spine-flexion-myths-truths-and-issues.pdf"
        },
        {
          "name": "Kelly Starrett",
          "url": "https://tim.blog/2023/04/01/kelly-starrett-transcript/"
        }
      ]
    },
    {
      "id": "should-you-use-a-research-peptide-y9f8",
      "question": "Should you use a research peptide like BPC-157 to heal an injury faster?",
      "image": "/images/crossfire/should-you-use-a-research-peptide-y9f8.webp?v=5fd64491",
      "people": [
        {
          "name": "Ben Greenfield",
          "url": "https://bengreenfieldlife.com/article/supplements-articles/how-to-use-bpc-157/"
        },
        {
          "name": "Judy Cho",
          "url": "https://www.nutritionwithjudy.com/peptides-root-cause-healing/"
        },
        {
          "name": "Marion Nestle",
          "url": "https://www.foodpolitics.com/2026/07/what-will-the-fda-do-about-peptides/"
        },
        {
          "name": "Jessica B. Steier",
          "url": "https://theunbiasedscipod.substack.com/p/cyclospora-peptides-and-the-great"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://ipscell.com/2026/07/potentially-highly-conflicted-pcac-meets-this-week-on-pop-peptides-but-no-waivers/"
        },
        {
          "name": "Gabrielle Lyon",
          "url": "https://dr-gabrielle-lyon.captivate.fm/episode/dont-inject-what-you-cant-verify-compounded-peptide-safety-explained"
        },
        {
          "name": "Timothy Caulfield",
          "url": "https://bsky.app/profile/caulfieldtim.bsky.social/post/3mrupyc6sik2v"
        }
      ]
    },
    {
      "id": "should-you-wear-sunscreen-every-day-fryo",
      "question": "Should you wear sunscreen every day, or cover up and skip it?",
      "image": "/images/crossfire/should-you-wear-sunscreen-every-day-fryo.webp?v=e10d9409",
      "people": [
        {
          "name": "Judy Cho",
          "url": "https://www.nutritionwithjudy.com/ditch-the-sunscreen/"
        },
        {
          "name": "Leslie Baumann",
          "url": "https://skintypesolutions.com/blogs/skincare/sunscreen-safety"
        }
      ]
    },
    {
      "id": "someone-i-trust-goes-to-a-2o8u",
      "question": "Someone I trust goes to a clinic that injects stem cells all over your body in one day. Should I?",
      "image": "/images/crossfire/someone-i-trust-goes-to-a-2o8u.webp?v=997e1522",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/how-adult-stem-cells-can-help-stop-pain-and-reverse-aging/"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://ipscell.com/2023/11/review-of-docere-clinics-run-by-harry-adelson-including-total-body-injections/"
        }
      ]
    },
    {
      "id": "there-are-stem-cell-clinics-everywhere-xawe",
      "question": "There are stem cell clinics everywhere now. Is that access, or is that a problem?",
      "image": "/images/crossfire/there-are-stem-cell-clinics-everywhere-xawe.webp?v=53ec4292",
      "people": [
        {
          "name": "Dave Asprey",
          "url": "https://daveasprey.com/what-are-stem-cells-types-27-03-19/"
        },
        {
          "name": "Paul Knoepfler",
          "url": "https://sciencebasedmedicine.org/stem-cell-clinics-and-unapproved-for-profit-human-experimentation/"
        }
      ]
    },
    {
      "id": "to-get-stronger-do-you-need-tnz0",
      "question": "To get stronger, do you need a handful of heavy sets a week or a lot of them?",
      "image": "/images/crossfire/to-get-stronger-do-you-need-tnz0.webp?v=93b5513c",
      "people": [
        {
          "name": "Andy Galpin",
          "url": "https://www.hubermanlab.com/episode/dr-andy-galpin-optimal-protocols-to-build-strength-and-grow-muscles"
        },
        {
          "name": "Jeff Nippard",
          "url": "https://www.youtube.com/watch?v=jeZb2gvsahQ"
        }
      ]
    },
    {
      "id": "what-makes-a-new-habit-stick-1108",
      "question": "What makes a new habit stick: repeating it for weeks, or feeling good the moment you do it?",
      "image": "/images/crossfire/what-makes-a-new-habit-stick-1108.webp?v=a60e60c7",
      "people": [
        {
          "name": "B.J. Fogg",
          "url": "https://ideas.ted.com/how-you-can-use-the-power-of-celebration-to-make-new-habits-stick/"
        },
        {
          "name": "James Clear",
          "url": "https://jamesclear.com/new-habit"
        }
      ]
    },
    {
      "id": "what-should-an-adhd-programme-change-1p1l",
      "question": "What should an ADHD programme change first: the person or the environment?",
      "image": "/images/crossfire/what-should-an-adhd-programme-change-1p1l.webp?v=a2fc18ca",
      "people": [
        {
          "name": "Russell Barkley",
          "url": "https://www.russellbarkley.org/factsheets/ADHD_EF_and_SR.pdf"
        },
        {
          "name": "Jessica McCabe",
          "url": "https://howtoadhdbook.com/"
        }
      ]
    },
    {
      "id": "what-should-someone-change-first-when-ct5l",
      "question": "What should someone change first when persistent pain has taken over daily life?",
      "image": "/images/crossfire/what-should-someone-change-first-when-ct5l.webp?v=83964ead",
      "people": [
        {
          "name": "Rachel Zoffness",
          "url": "https://www.zoffness.com/books/pain-management-workbook"
        },
        {
          "name": "Peter O'Sullivan",
          "url": "https://www.iasp-pain.org/wp-content/uploads/2024/06/cognitive-functional-therapy-msk-fact-sheet_R1.pdf"
        }
      ]
    },
    {
      "id": "when-a-low-carb-diet-works-i9se",
      "question": "When a low-carb diet works for me, what is it that's actually working?",
      "image": "/images/crossfire/when-a-low-carb-diet-works-i9se.webp?v=876c1a3a",
      "people": [
        {
          "name": "Benjamin T. Bikman",
          "url": "https://shows.acast.com/the-metabolic-classroom/episodes/energy-toxicity-and-insulin-resistance"
        },
        {
          "name": "Layne Norton",
          "url": "https://biolayne.com/podcasts/dr-layne-norton-podcast/what-really-matters-for-fat-loss-episode-6/"
        }
      ]
    },
    {
      "id": "when-a-rewarding-behavior-or-substance-4l8f",
      "question": "When a rewarding behavior or substance feels out of control, should the first step be abstinence?",
      "image": "/images/crossfire/when-a-rewarding-behavior-or-substance-4l8f.webp?v=663ef6da",
      "people": [
        {
          "name": "Anna Lembke",
          "url": "https://engineering.stanford.edu/news/future-addiction"
        },
        {
          "name": "Sarah Wakeman",
          "url": "https://www.massgeneralbrigham.org/en/about/newsroom/articles/substance-use-disorders"
        }
      ]
    },
    {
      "id": "when-i-cut-back-on-processed-1idu",
      "question": "When I cut back on processed food and my numbers get better, what is it that's actually working?",
      "image": "/images/crossfire/when-i-cut-back-on-processed-1idu.webp?v=85308471",
      "people": [
        {
          "name": "Robert H. Lustig",
          "url": "https://pubmed.ncbi.nlm.nih.gov/26499447/"
        },
        {
          "name": "Kevin D. Hall",
          "url": "https://pubmed.ncbi.nlm.nih.gov/31105044/"
        }
      ]
    },
    {
      "id": "when-should-i-stop-drinking-coffee-tj5d",
      "question": "When should I stop drinking coffee: the same time as everyone else, or a time that depends on me?",
      "image": "/images/crossfire/when-should-i-stop-drinking-coffee-tj5d.webp?v=c4564071",
      "people": [
        {
          "name": "Michael J. Breus",
          "url": "https://sleepdoctor.com/pages/chronotypes/wolf-chronotype,"
        },
        {
          "name": "Matthew Walker",
          "url": "https://themattwalkerpodcast.buzzsprout.com/1821163/episodes/10897112-25-optimising-your-sleep,"
        }
      ]
    },
    {
      "id": "when-two-coaches-say-zone-2-jqc9",
      "question": "When two coaches say Zone 2, do they mean the same intensity?",
      "image": "/images/crossfire/when-two-coaches-say-zone-2-jqc9.webp?v=e9a23dbe",
      "people": [
        {
          "name": "Iñigo San Millán",
          "url": "https://inigosanmillan.substack.com/p/the-new-metabolic-map-part-ii-how"
        },
        {
          "name": "Stephen Seiler",
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12491423/"
        }
      ]
    },
    {
      "id": "when-you-need-to-get-down-vqal",
      "question": "When you need to get down to the floor, should you deep squat or lunge?",
      "image": "/images/crossfire/when-you-need-to-get-down-vqal.webp?v=b07d3189",
      "people": [
        {
          "name": "Ben Patrick",
          "url": "https://tim.blog/2025/11/13/ben-patrick-kneesovertoesguy-transcript/"
        },
        {
          "name": "Stuart McGill",
          "url": "https://www.backfitpro.com/pdf/selecting_back_exercises.pdf"
        }
      ]
    },
    {
      "id": "will-my-insomnia-shorten-my-life-z74q",
      "question": "Will my insomnia shorten my life?",
      "image": "/images/crossfire/will-my-insomnia-shorten-my-life-z74q.webp?v=e1fd3fa0",
      "people": [
        {
          "name": "Matthew Walker",
          "url": "https://www.ted.com/talks/matt_walker_sleep_is_your_superpower"
        },
        {
          "name": "Jade Wu",
          "url": "https://www.drjadewu.com/resources"
        }
      ]
    }
  ]
}
